<template>
  <div id="invoice-page">


    <b-row>
      <span
        class="col-4 w-full"
        style="font-size: 24px; color: rgb(115, 103, 240); font-weight: 500;margin-bottom:20px;"
      >
         Credit Account Details
      </span>

    </b-row>





    <!-- <div class="row">
      <b-button
        @click="viewLeadData()"
        v-ripple.400="'rgba(30, 30, 30, 0.15)'"
        variant="outline-none"
        style="margin-left:20px;"
      >
         Lead Details
      </b-button>
      <b-button
        @click="viewCreditData()"
        v-ripple.400="'rgba(255, 255, 255, 0.15)'"
        variant="primary"
        style="margin-left:20px"
      >
        Credit Score Details
      </b-button>
    </div> -->

    <vx-card style="padding: 10px">
      <vs-alert
        :active.sync="GeneralError"
        closable
        icon-pack="feather"
        close-icon="icon-x"
        color="danger"
        title="ERROR!!!"
        style="text-align: center"
        @click="dismissError()"
      >
        {{ errorMessage }}
      </vs-alert>
      <b-row style="border-bottom: 1px solid rgba(194, 183, 251, 1);">
        <span
          class="col-8 w-full"
          style="font-size: 18px; color: #5e5873; font-weight: 500;
    bottom: 10px;"
        >
        <div class="row" style="margin-left: 0px;margin-left: -1rem;">
        <img
          src="../../assets/icons/CreditSummary.png"
          alt="login"

        />
        <div style="margin-top: 7px;margin-left: 10px;color:#7367F0;">
          Account Summary
        </div>
        </div>
        </span>

      </b-row>

      <b-row
        style="
        margin-left: -30px;
          padding-top: 15px;

        "
      >
        <b-col md="3" v-if="caisDetails.portfolioType === 'I'">
          <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
            Portfolio Type </span
          ><br />
          <span style="font-size: 12px; color: #5e5873; font-weight: 500">
            Individual
          </span>
        </b-col>
        <b-col md="3" v-else-if="caisDetails.portfolioType">
          <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
            Portfolio Type </span
          ><br />
          <span style="font-size: 12px; color: #5e5873; font-weight: 500">
            {{caisDetails.portfolioType}}
          </span>
        </b-col>

        <b-col md="3" v-else>
          <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
            Portfolio Type </span
          ><br />
          <span style="font-size: 12px; color: #5e5873; font-weight: 500">
            __ __
          </span>
        </b-col>
        <b-col md="3" >
          <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
            Account Type </span
          ><br />
          <div style="font-size: 12px; color: #5e5873; font-weight: 500" v-if="caisDetails.accountType ==='1'">Auto Loan</div>
          <div style="font-size: 12px; color: #5e5873; font-weight: 500" v-else-if="caisDetails.accountType ==='01'">Auto Loan</div>
          <div style="font-size: 12px; color: #5e5873; font-weight: 500" v-else-if="caisDetails.accountType ==='2'">Housing Loan</div>
          <div style="font-size: 12px; color: #5e5873; font-weight: 500" v-else-if="caisDetails.accountType ==='02'">Housing Loan</div>
          <div style="font-size: 12px; color: #5e5873; font-weight: 500" v-else-if="caisDetails.accountType ==='3'">Property Loan</div>
          <div style="font-size: 12px; color: #5e5873; font-weight: 500" v-else-if="caisDetails.accountType ==='03'">Property Loan</div>
          <div style="font-size: 12px; color: #5e5873; font-weight: 500" v-else-if="caisDetails.accountType ==='4'">Loan Against Shares/Securities</div>
          <div style="font-size: 12px; color: #5e5873; font-weight: 500" v-else-if="caisDetails.accountType ==='04'">Loan Against Shares/Securities</div>
          <div style="font-size: 12px; color: #5e5873; font-weight: 500" v-else-if="caisDetails.accountType ==='5'">Personal Loan</div>
          <div style="font-size: 12px; color: #5e5873; font-weight: 500" v-else-if="caisDetails.accountType ==='05'">Personal Loan</div>
          <div style="font-size: 12px; color: #5e5873; font-weight: 500" v-else-if="caisDetails.accountType ==='6'">Consumer Loan</div>
          <div style="font-size: 12px; color: #5e5873; font-weight: 500" v-else-if="caisDetails.accountType ==='06'">Consumer Loan</div>
          <div style="font-size: 12px; color: #5e5873; font-weight: 500" v-else-if="caisDetails.accountType ==='7'">Gold Loan</div>
          <div style="font-size: 12px; color: #5e5873; font-weight: 500" v-else-if="caisDetails.accountType ==='07'">Gold Loan</div>
          <div style="font-size: 12px; color: #5e5873; font-weight: 500" v-else-if="caisDetails.accountType ==='8'">Educational Loan</div>
          <div style="font-size: 12px; color: #5e5873; font-weight: 500" v-else-if="caisDetails.accountType ==='08'">Educational Loan</div>
          <div style="font-size: 12px; color: #5e5873; font-weight: 500" v-else-if="caisDetails.accountType ==='9'">Loan To Professional</div>
          <div style="font-size: 12px; color: #5e5873; font-weight: 500" v-else-if="caisDetails.accountType ==='09'">Loan To Professional</div>
          <div style="font-size: 12px; color: #5e5873; font-weight: 500" v-else-if="caisDetails.accountType ==='10'">Credit Card</div>
          <div style="font-size: 12px; color: #5e5873; font-weight: 500" v-else-if="caisDetails.accountType ==='11'">Leasing</div>
          <div style="font-size: 12px; color: #5e5873; font-weight: 500" v-else-if="caisDetails.accountType ==='12'">Overdraft</div>
          <div style="font-size: 12px; color: #5e5873; font-weight: 500" v-else-if="caisDetails.accountType ==='13'">Two Wheeler Loan</div>
          <div style="font-size: 12px; color: #5e5873; font-weight: 500" v-else-if="caisDetails.accountType ==='14'">Non Funded Credit Facility</div>
          <div style="font-size: 12px; color: #5e5873; font-weight: 500" v-else-if="caisDetails.accountType ==='15'">Loan Against Bank Deposit</div>
          <div style="font-size: 12px; color: #5e5873; font-weight: 500" v-else-if="caisDetails.accountType ==='16'">Fleet Card</div>
          <div style="font-size: 12px; color: #5e5873; font-weight: 500" v-else-if="caisDetails.accountType ==='17'">Commercial Vehicle Loan</div>
          <div style="font-size: 12px; color: #5e5873; font-weight: 500" v-else-if="caisDetails.accountType ==='18'">Telco – Wireless</div>
          <div style="font-size: 12px; color: #5e5873; font-weight: 500" v-else-if="caisDetails.accountType ==='19'">Telco – Broadband</div>
          <div style="font-size: 12px; color: #5e5873; font-weight: 500" v-else-if="caisDetails.accountType ==='20'">Telco – Landline</div>
          <div style="font-size: 12px; color: #5e5873; font-weight: 500" v-else-if="caisDetails.accountType ==='23'">GECL Secured</div>
          <div style="font-size: 12px; color: #5e5873; font-weight: 500" v-else-if="caisDetails.accountType ==='24'">GECL Unsecured</div>
          <div style="font-size: 12px; color: #5e5873; font-weight: 500" v-else-if="caisDetails.accountType ==='31'">Secured Credit Card</div>
          <div style="font-size: 12px; color: #5e5873; font-weight: 500" v-else-if="caisDetails.accountType ==='32'">Used Car Loan</div>
          <div style="font-size: 12px; color: #5e5873; font-weight: 500" v-else-if="caisDetails.accountType ==='33'">Construction Equipment Loan</div>
          <div style="font-size: 12px; color: #5e5873; font-weight: 500" v-else-if="caisDetails.accountType ==='34'">Tractor Loan</div>
          <div style="font-size: 12px; color: #5e5873; font-weight: 500" v-else-if="caisDetails.accountType ==='35'">Corporate Credit Card</div>
          <div style="font-size: 12px; color: #5e5873; font-weight: 500" v-else-if="caisDetails.accountType ==='36'">Kisan Credit Card</div>
          <div style="font-size: 12px; color: #5e5873; font-weight: 500" v-else-if="caisDetails.accountType ==='37'">Loan on Credit Card</div>
          <div style="font-size: 12px; color: #5e5873; font-weight: 500" v-else-if="caisDetails.accountType ==='38'">Prime Minister Jaan Dhan Yojana - Overdraft</div>
          <div style="font-size: 12px; color: #5e5873; font-weight: 500" v-else-if="caisDetails.accountType ==='39'">Mudra Loans – Shishu / Kishor / Tarun</div>
          <div style="font-size: 12px; color: #5e5873; font-weight: 500" v-else-if="caisDetails.accountType ==='40'">Microfinance – Business Loan</div>
          <div style="font-size: 12px; color: #5e5873; font-weight: 500" v-else-if="caisDetails.accountType ==='41'">Microfinance – Personal Loan</div>
          <div style="font-size: 12px; color: #5e5873; font-weight: 500" v-else-if="caisDetails.accountType ==='42'">Microfinance – Housing Loan</div>
          <div style="font-size: 12px; color: #5e5873; font-weight: 500" v-else-if="caisDetails.accountType ==='43'">Microfinance – Others</div>
          <div style="font-size: 12px; color: #5e5873; font-weight: 500" v-else-if="caisDetails.accountType ==='44'">Pradhan Mantri Awas Yojana - Credit Link Subsidy Scheme MAY CLSS</div>
          <div style="font-size: 12px; color: #5e5873; font-weight: 500" v-else-if="caisDetails.accountType ==='45'">P2P Personal Loan</div>
          <div style="font-size: 12px; color: #5e5873; font-weight: 500" v-else-if="caisDetails.accountType ==='46'">P2P Auto Loan</div>
          <div style="font-size: 12px; color: #5e5873; font-weight: 500" v-else-if="caisDetails.accountType ==='47'">P2P Education Loan</div>
          <div style="font-size: 12px; color: #5e5873; font-weight: 500" v-else-if="caisDetails.accountType ==='51'">Business Loan-General</div>
          <div style="font-size: 12px; color: #5e5873; font-weight: 500" v-else-if="caisDetails.accountType ==='52'">Business Loan-Priority Sector-Small Business</div>
          <div style="font-size: 12px; color: #5e5873; font-weight: 500" v-else-if="caisDetails.accountType ==='53'">Business Loan-Priority Sector-Agriculture</div>
          <div style="font-size: 12px; color: #5e5873; font-weight: 500" v-else-if="caisDetails.accountType ==='54'">Business Loan-Priority Sector-Others</div>
          <div style="font-size: 12px; color: #5e5873; font-weight: 500" v-else-if="caisDetails.accountType ==='55'">Business Non-Funded Credit Facility-General</div>
          <div style="font-size: 12px; color: #5e5873; font-weight: 500" v-else-if="caisDetails.accountType ==='56'">Business Non-Funded Credit Facility-Priority Sector-Small Business</div>
          <div style="font-size: 12px; color: #5e5873; font-weight: 500" v-else-if="caisDetails.accountType ==='57'">Business Non-Funded Credit Facility-Priority Sector-Agriculture</div>
          <div style="font-size: 12px; color: #5e5873; font-weight: 500" v-else-if="caisDetails.accountType ==='58'">Business Non-Funded Credit Facility-Priority Sector-Others</div>
          <div style="font-size: 12px; color: #5e5873; font-weight: 500" v-else-if="caisDetails.accountType ==='59'">Business Loans Against Bank Deposit</div>
          <div style="font-size: 12px; color: #5e5873; font-weight: 500" v-else-if="caisDetails.accountType ==='60'">Staff Loan</div>
          <div style="font-size: 12px; color: #5e5873; font-weight: 500" v-else-if="caisDetails.accountType ==='61'">Business Loan - Unsecured</div>
          <div style="font-size: 12px; color: #5e5873; font-weight: 500" v-else-if="caisDetails.accountType ==='00'">Others</div>
          <div style="font-size: 12px; color: #5e5873; font-weight: 500" v-else>__ __</div>
        </b-col>


        <b-col md="3" v-if="caisDetails.openDate">
          <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
            Account Open Date </span
          ><br />
          <span style="font-size: 12px; color: #5e5873; font-weight: 500">
              {{ caisDetails.openDate | moment("YYYY-MM-DD")  }}
          </span>
        </b-col>
        <b-col md="3" v-else>
          <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
            Account Open Date </span
          ><br />
          <span style="font-size: 12px; color: #5e5873; font-weight: 500">
              __ __
          </span>
        </b-col>

        <b-col md="3" style="" v-if="caisDetails.creditLimitAmount">
          <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
            Credit Limit Amount </span
          ><br />
          <span style="font-size: 12px; color: #5e5873; font-weight: 500">
            {{ caisDetails.creditLimitAmount }}
          </span>
        </b-col>
        <b-col md="3" style="" v-else>
          <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
            Credit Limit Amount </span
          ><br />
          <span style="font-size: 12px; color: #5e5873; font-weight: 500">
            __ __
          </span>
        </b-col>

        <b-col md="3" style="padding-top: 10px" v-if="caisDetails.currentBalance">
          <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
            Current Balance </span
          ><br />
          <span style="font-size: 12px; color: #5e5873; font-weight: 500">
            {{ caisDetails.currentBalance.toLocaleString('en-IN', {minimumFractionDigits: 0, maximumFractionDigits: 2}) }}
          </span>
        </b-col>
        <b-col md="3" style="padding-top: 10px" v-else>
          <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
            Current Balance </span
          ><br />
          <span style="font-size: 12px; color: #5e5873; font-weight: 500">
            __ __
          </span>
        </b-col>

        <b-col md="3" style="padding-top: 10px" v-if="caisDetails.amountPastDue">
          <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
            Amount Past Due </span
          ><br />
          <span style="font-size: 12px; color: #5e5873; font-weight: 500">
            {{ caisDetails.amountPastDue  }}
          </span>
        </b-col>
        <b-col md="3" style="padding-top: 10px" v-else>
          <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
            Amount Past Due </span
          ><br />
          <span style="font-size: 12px; color: #5e5873; font-weight: 500">
            __ __
          </span>
        </b-col>

        <b-col md="3" style="padding-top: 10px" v-if="caisDetails.dateReported">
          <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
            Date Reported </span
          ><br />
          <span style="font-size: 12px; color: #5e5873; font-weight: 500">
            {{ caisDetails.dateReported | moment("YYYY-MM-DD")  }}
          </span>
        </b-col>
        <b-col md="3" style="padding-top: 10px" v-else>
          <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
            Date Reported </span
          ><br />
          <span style="font-size: 12px; color: #5e5873; font-weight: 500">
            __ __
          </span>
        </b-col>

        <b-col md="3" style="padding-top: 10px" v-if="caisDetails.creditLimitAmount">
          <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
            Original Loan Amount </span
          ><br />
          <span style="font-size: 12px; color: #5e5873; font-weight: 500">
            {{ caisDetails.creditLimitAmount }}
          </span>
        </b-col>
        <b-col md="3" style="padding-top: 10px" v-else>
          <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
            Original Loan Amount </span
          ><br />
          <span style="font-size: 12px; color: #5e5873; font-weight: 500">
            __ __
          </span>
        </b-col>

        <b-col md="3" style="padding-top: 10px" v-if="caisDetails.termsDuration">
          <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
            Term Duration(Months) </span
          ><br />
          <span style="font-size: 12px; color: #5e5873; font-weight: 500">
            {{ caisDetails.termsDuration }}
          </span>
        </b-col>

        <b-col md="3" style="padding-top: 10px" v-else>
          <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
            Term Duration(Months) </span
          ><br />
          <span style="font-size: 12px; color: #5e5873; font-weight: 500">
            __ __
          </span>
        </b-col>
        <b-col md="3" style="padding-top: 10px" v-if="caisDetails.termsFrequency">
          <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
            Term Frequency </span
          ><br />
          <span style="font-size: 12px; color: #5e5873; font-weight: 500">
            {{ caisDetails.termsFrequency }}
          </span>
        </b-col>
        <b-col md="3" style="padding-top: 10px" v-else>
          <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
            Term Frequency </span
          ><br />
          <span style="font-size: 12px; color: #5e5873; font-weight: 500">
            __ __
          </span>
        </b-col>
        <b-col md="3" style="padding-top: 10px" v-if="caisDetails.rateofInterest">
          <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
            Rate of Interest </span
          ><br />
          <span style="font-size: 12px; color: #5e5873; font-weight: 500">
            {{ caisDetails.rateofInterest }}
          </span>
        </b-col>
        <b-col md="3" style="padding-top: 10px" v-else>
          <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
            Rate of Interest </span
          ><br />
          <span style="font-size: 12px; color: #5e5873; font-weight: 500">
            __ __
          </span>
        </b-col>

        <b-col md="3" style="padding-top: 10px" v-if="caisDetails.scheduledMonthlyPaymentAmount">
          <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
          EMI Amount </span
          ><br />
          <span style="font-size: 12px; color: #5e5873; font-weight: 500">
            {{ caisDetails.scheduledMonthlyPaymentAmount }}
          </span>
        </b-col>
        <b-col md="3" style="padding-top: 10px" v-else>
          <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
          EMI Amount </span
          ><br />
          <span style="font-size: 12px; color: #5e5873; font-weight: 500">
            __ __
          </span>
        </b-col>

        <b-col md="3" style="padding-top: 10px" v-if="caisDetails.accountStatus">
          <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
          Account Status </span
          ><br />
          <span style="font-size: 12px; color: #5e5873; font-weight: 500" v-if="caisDetails.accountStatus ==='12' || caisDetails.accountStatus ==='13'|| caisDetails.accountStatus ==='14'|| caisDetails.accountStatus ==='15'|| caisDetails.accountStatus ==='16' || caisDetails.accountStatus ==='17'">
            Closed
          </span>
          <span style="font-size: 12px; color: #5e5873; font-weight: 500" v-else-if="caisDetails.accountStatus ==='11' || caisDetails.accountStatus ==='71'|| caisDetails.accountStatus ==='78'|| caisDetails.accountStatus ==='80'|| caisDetails.accountStatus ==='82' || caisDetails.accountStatus ==='83' || caisDetails.accountStatus ==='84'|| caisDetails.accountStatus ==='21' || caisDetails.accountStatus ==='22' || caisDetails.accountStatus ==='23' || caisDetails.accountStatus ==='24' || caisDetails.accountStatus ==='25' || caisDetails.accountStatus ==='DEFAULTVALUE'">
            Active
          </span>

          <div


            style="font-size: 12px; color: #5e5873; font-weight: 500"
            v-else-if="caisDetails.accountStatus ==='00'"
          >
            No Suit Filed
          </div>
          <div


            style="font-size: 12px; color: #5e5873; font-weight: 500"
            v-else-if="caisDetails.accountStatus ==='89'"
          >
            Wilful default
          </div>

          <div


            style="font-size: 12px; color: #5e5873; font-weight: 500"
            v-else-if="caisDetails.accountStatus ==='93'"
          >
            Suit Filed(Wilful default)
          </div>
          <div


            style="font-size: 12px; color: #5e5873; font-weight: 500"
            v-else-if="caisDetails.accountStatus ==='97'"
          >
            Suit Filed(Wilful Default) and Written-off
          </div>
          <div


            style="font-size: 12px; color: #5e5873; font-weight: 500"
            v-else-if="caisDetails.accountStatus ==='30'"
          >
            Restructured
          </div>

          <div


            style="font-size: 12px; color: #5e5873; font-weight: 500"
            v-else-if="caisDetails.accountStatus ==='31'"
          >
            Restructured Loan (Govt. Mandated)
          </div>
          <div


            style="font-size: 12px; color: #5e5873; font-weight: 500"
            v-else-if="caisDetails.accountStatus ==='32'"
          >
            Settled
          </div>
          <div


            style="font-size: 12px; color: #5e5873; font-weight: 500"
            v-else-if="caisDetails.accountStatus ==='33'"
          >
            Post (WO) Settled
          </div>

          <div


            style="font-size: 12px; color: #5e5873; font-weight: 500"
            v-else-if="caisDetails.accountStatus ==='34'"
          >
            Account Sold
          </div>
          <div


            style="font-size: 12px; color: #5e5873; font-weight: 500"
            v-else-if="caisDetails.accountStatus ==='35'"
          >
            Written Off and Account Sold
          </div>

          <div


            style="font-size: 12px; color: #5e5873; font-weight: 500"
            v-else-if="caisDetails.accountStatus ==='36'"
          >
            Account Purchased
          </div>
          <div


            style="font-size: 12px; color: #5e5873; font-weight: 500"
            v-else-if="caisDetails.accountStatus ==='37'"
          >
            Account Purchased and Written Off
          </div>
          <div


            style="font-size: 12px; color: #5e5873; font-weight: 500"
            v-else-if="caisDetails.accountStatus ==='38'"
          >
            Account Purchased and Settled
          </div>
          <div


            style="font-size: 12px; color: #5e5873; font-weight: 500"
            v-else-if="caisDetails.accountStatus ==='39'"
          >
            Account Purchased and Restructured
          </div>
          <div


            style="font-size: 12px; color: #5e5873; font-weight: 500"
            v-else-if="caisDetails.accountStatus ==='40'"
          >
            Status Cleared
          </div>
          <div


            style="font-size: 12px; color: #5e5873; font-weight: 500"
            v-else-if="caisDetails.accountStatus ==='41'"
          >
            Restructured Loan
          </div>
          <div


            style="font-size: 12px; color: #5e5873; font-weight: 500"
            v-else-if="caisDetails.accountStatus ==='42'"
          >
            Restructured Loan (Govt. Mandated)
          </div>
          <div


            style="font-size: 12px; color: #5e5873; font-weight: 500"
            v-else-if="caisDetails.accountStatus ==='43'"
          >
            Written-off
          </div>
          <div


            style="font-size: 12px; color: #5e5873; font-weight: 500"
            v-else-if="caisDetails.accountStatus ==='44'"
          >
            Settled
          </div>
          <div


            style="font-size: 12px; color: #5e5873; font-weight: 500"
            v-else-if="caisDetails.accountStatus ==='45'"
          >
            Post (WO) Settled
          </div>
          <div


            style="font-size: 12px; color: #5e5873; font-weight: 500"
            v-else-if="caisDetails.accountStatus ==='46'"
          >
            Account Sold
          </div>
          <div


            style="font-size: 12px; color: #5e5873; font-weight: 500"
            v-else-if="caisDetails.accountStatus ==='47'"
          >
            Written Off and Account Sold
          </div>
          <div


            style="font-size: 12px; color: #5e5873; font-weight: 500"
            v-else-if="caisDetails.accountStatus ==='48'"
          >
            Account Purchased
          </div>
          <div


            style="font-size: 12px; color: #5e5873; font-weight: 500"
            v-else-if="caisDetails.accountStatus ==='49'"
          >
            Account Purchased and Written Off
          </div>
          <div


            style="font-size: 12px; color: #5e5873; font-weight: 500"
            v-else-if="caisDetails.accountStatus ==='50'"
          >
            Account Purchased and Settled
          </div>
          <div


            style="font-size: 12px; color: #5e5873; font-weight: 500"
            v-else-if="caisDetails.accountStatus ==='51'"
          >
            Account Purchased and Restructured
          </div>
          <div


            style="font-size: 12px; color: #5e5873; font-weight: 500"
            v-else-if="caisDetails.accountStatus ==='52'"
          >
            Status Cleared
          </div>
          <div


            style="font-size: 12px; color: #5e5873; font-weight: 500"
            v-else-if="caisDetails.accountStatus ==='53'"
          >
            Suit Filed
          </div>
          <div


            style="font-size: 12px; color: #5e5873; font-weight: 500"
            v-else-if="caisDetails.accountStatus ==='54'"
          >
            Suit Filed and Written-off
          </div>
          <div


            style="font-size: 12px; color: #5e5873; font-weight: 500"
            v-else-if="caisDetails.accountStatus ==='55'"
          >
            Suit Filed and Settled
          </div>
          <div


            style="font-size: 12px; color: #5e5873; font-weight: 500"
            v-else-if="caisDetails.accountStatus ==='56'"
          >
            Suit Filed and Post (WO) Settled
          </div>
          <div


            style="font-size: 12px; color: #5e5873; font-weight: 500"
            v-else-if="caisDetails.accountStatus ==='57'"
          >
            Suit Filed and Account Sold
          </div>
          <div


            style="font-size: 12px; color: #5e5873; font-weight: 500"
            v-else-if="caisDetails.accountStatus ==='58'"
          >
            Suit Filed and Written Off and Account Sold
          </div>
          <div


            style="font-size: 12px; color: #5e5873; font-weight: 500"
            v-else-if="caisDetails.accountStatus ==='59'"
          >
            Suit Filed and Account Purchased
          </div>
          <div


            style="font-size: 12px; color: #5e5873; font-weight: 500"
            v-else-if="caisDetails.accountStatus ==='60'"
          >
            Suit Filed and Account Purchased and Written Off
          </div>
          <div


            style="font-size: 12px; color: #5e5873; font-weight: 500"
            v-else-if="caisDetails.accountStatus ==='61'"
          >
            Suit Filed and Account Purchased and Settled
          </div>
          <div


            style="font-size: 12px; color: #5e5873; font-weight: 500"
            v-else-if="caisDetails.accountStatus ==='62'"
          >
            Suit Filed and Account Purchased and Restructured
          </div>
          <div


            style="font-size: 12px; color: #5e5873; font-weight: 500"
            v-else-if="caisDetails.accountStatus ==='63'"
          >
            Suit Filed and Status Cleared
          </div>
          <div


            style="font-size: 12px; color: #5e5873; font-weight: 500"
            v-else-if="caisDetails.accountStatus ==='64'"
          >
            Wilful Default and Restructured Loan
          </div>
          <div


            style="font-size: 12px; color: #5e5873; font-weight: 500"
            v-else-if="caisDetails.accountStatus ==='65'"
          >
            Wilful Default and Restructured Loan (Govt. Mandated)
          </div>
          <div


            style="font-size: 12px; color: #5e5873; font-weight: 500"
            v-else-if="caisDetails.accountStatus ==='66'"
          >
            Wilful Default and Settled
          </div>
          <div


            style="font-size: 12px; color: #5e5873; font-weight: 500"
            v-else-if="caisDetails.accountStatus ==='67'"
          >
            Wilful Default and Post (WO) Settled
          </div>
          <div


            style="font-size: 12px; color: #5e5873; font-weight: 500"
            v-else-if="caisDetails.accountStatus ==='68'"
          >
            Wilful Default and Account Sold
          </div>
          <div


            style="font-size: 12px; color: #5e5873; font-weight: 500"
            v-else-if="caisDetails.accountStatus ==='69'"
          >
            Wilful Default and Written Off and Account Sold
          </div>
          <div


            style="font-size: 12px; color: #5e5873; font-weight: 500"
            v-else-if="caisDetails.accountStatus ==='70'"
          >
            Wilful Default and Account Purchased
          </div>
          <div


            style="font-size: 12px; color: #5e5873; font-weight: 500"
            v-else-if="caisDetails.accountStatus ==='72'"
          >
            Wilful Default and Account Purchased and Written Off
          </div>
          <div


            style="font-size: 12px; color: #5e5873; font-weight: 500"
            v-else-if="caisDetails.accountStatus ==='73'"
          >
            Wilful Default and Account Purchased and Settled
          </div>
          <div


            style="font-size: 12px; color: #5e5873; font-weight: 500"
            v-else-if="caisDetails.accountStatus ==='74'"
          >
            Wilful Default and Account Purchased and Restructured
          </div>
          <div


            style="font-size: 12px; color: #5e5873; font-weight: 500"
            v-else-if="caisDetails.accountStatus ==='75'"
          >
            Wilful Default and Status Cleared
          </div>
          <div


            style="font-size: 12px; color: #5e5873; font-weight: 500"
            v-else-if="caisDetails.accountStatus ==='76'"
          >
            Suit filed (Wilful default) and Restructured
          </div>
          <div


            style="font-size: 12px; color: #5e5873; font-weight: 500"
            v-else-if="caisDetails.accountStatus ==='77'"
          >
            Suit filed (Wilful default) and Restructured Loan (Govt. Mandated)
          </div>
          <div


            style="font-size: 12px; color: #5e5873; font-weight: 500"
            v-else-if="caisDetails.accountStatus ==='79'"
          >
            Suit filed (Wilful default) and Settled
          </div>
          <div


            style="font-size: 12px; color: #5e5873; font-weight: 500"
            v-else-if="caisDetails.accountStatus ==='81'"
          >
            Suit filed (Wilful default) and Post (WO) Settled
          </div>
          <div


            style="font-size: 12px; color: #5e5873; font-weight: 500"
            v-else-if="caisDetails.accountStatus ==='85'"
          >
            Suit filed (Wilful default) and Account Sold
          </div>
          <div


            style="font-size: 12px; color: #5e5873; font-weight: 500"
            v-else-if="caisDetails.accountStatus ==='86'"
          >
            Suit filed (Wilful default) and Written Off and Account Sold
          </div>
          <div


            style="font-size: 12px; color: #5e5873; font-weight: 500"
            v-else-if="caisDetails.accountStatus ==='87'"
          >
            Suit filed (Wilful default) and Account Purchased
          </div>
          <div


            style="font-size: 12px; color: #5e5873; font-weight: 500"
            v-else-if="caisDetails.accountStatus ==='88'"
          >
            Suit filed (Wilful default) and Account Purchased and Written Off
          </div>
          <div


            style="font-size: 12px; color: #5e5873; font-weight: 500"
            v-else-if="caisDetails.accountStatus ==='94'"
          >
            Suit filed (Wilful default) and Account Purchased and Settled
          </div>
          <div


            style="font-size: 12px; color: #5e5873; font-weight: 500"
            v-else-if="caisDetails.accountStatus ==='90'"
          >
            Suit filed (Wilful default) and Account Purchased and Restructured
          </div>
          <div


            style="font-size: 12px; color: #5e5873; font-weight: 500"
            v-else-if="caisDetails.accountStatus ==='91'"
          >
            Suit filed (Wilful default) and Status Cleared
          </div>
          <span style="font-size: 12px; color: #5e5873; font-weight: 500" v-else>
            Default
          </span>
        </b-col>

        <b-col md="3" style="padding-top: 10px" v-else>
          <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
          Account Status </span
          ><br />
          <span style="font-size: 12px; color: #5e5873; font-weight: 500">
            __ __
          </span>

        </b-col>

        <b-col md="3" style="padding-top: 10px" v-if="caisDetails.paymentRatingDescription">
          <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
          Payment Rating </span
          ><br />
          <span style="font-size: 12px; color: #5e5873; font-weight: 500">
            {{ caisDetails.paymentRatingDescription }}
          </span>
        </b-col>

        <b-col md="3" style="padding-top: 10px" v-else>
          <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
          Payment Rating </span
          ><br />
          <span style="font-size: 12px; color: #5e5873; font-weight: 500">
            __ __
          </span>
        </b-col>

        <b-col md="3" style="padding-top: 10px" v-if="caisDetails.currentBalance">
          <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
          Current Balance </span
          ><br />
          <span style="font-size: 12px; color: #5e5873; font-weight: 500">
            {{ caisDetails.currentBalance.toLocaleString('en-IN', {minimumFractionDigits: 0, maximumFractionDigits: 2}) }}
          </span>
        </b-col>
        <b-col md="3" style="padding-top: 10px" v-else>
          <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
          Current Balance </span
          ><br />
          <span style="font-size: 12px; color: #5e5873; font-weight: 500">
            __ __
          </span>
        </b-col>
        <b-col md="3" style="padding-top: 10px" v-if="caisDetails.amountPastDue">
          <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
          Amount Past Due </span
          ><br />
          <span style="font-size: 12px; color: #5e5873; font-weight: 500">
            {{ caisDetails.amountPastDue }}
          </span>
        </b-col>
        <b-col md="3" style="padding-top: 10px" v-else>
          <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
          Amount Past Due </span
          ><br />
          <span style="font-size: 12px; color: #5e5873; font-weight: 500">
            __ __
          </span>
        </b-col>

        <b-col md="3" style="padding-top: 10px" v-if="caisDetails.originalChargeoffAmount">
          <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
          Original Charge off Amount </span
          ><br />
          <span style="font-size: 12px; color: #5e5873; font-weight: 500">
            {{ caisDetails.originalChargeoffAmount }}
          </span>
        </b-col>
        <b-col md="3" style="padding-top: 10px" v-else>
          <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
          Original Charge off Amount </span
          ><br />
          <span style="font-size: 12px; color: #5e5873; font-weight: 500">
          __ __
          </span>
        </b-col>

        <b-col md="3" style="padding-top: 10px" v-if="caisDetails.dateOfFirstDelinquency">
          <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
          Date of First Delinquency </span
          ><br />
          <span style="font-size: 12px; color: #5e5873; font-weight: 500">
            {{ caisDetails.dateOfFirstDelinquency }}
          </span>
        </b-col>
        <b-col md="3" style="padding-top: 10px" v-else>
          <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
          Date of First Delinquency </span
          ><br />
          <span style="font-size: 12px; color: #5e5873; font-weight: 500">
            __ __
          </span>
        </b-col>

        <b-col md="3" style="padding-top: 10px" v-if="caisDetails.dateClosed">
          <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
          Date Closed </span
          ><br />
          <span style="font-size: 12px; color: #5e5873; font-weight: 500">
            {{ caisDetails.dateClosed }}
          </span>
        </b-col>
        <b-col md="3" style="padding-top: 10px" v-else>
          <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
          Date Closed </span
          ><br />
          <span style="font-size: 12px; color: #5e5873; font-weight: 500">
            __ __
          </span>
        </b-col>
        <b-col md="3" style="padding-top: 10px" v-if="caisDetails.dateofLastPayment">
          <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
          Date of Last Payment </span
          ><br />
          <span style="font-size: 12px; color: #5e5873; font-weight: 500">
            {{ caisDetails.dateofLastPayment | moment("YYYY-MM-DD") }}
          </span>
        </b-col>
        <b-col md="3" style="padding-top: 10px" v-else>
          <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
          Date of Last Payment </span
          ><br />
          <span style="font-size: 12px; color: #5e5873; font-weight: 500">
            __ __
          </span>
        </b-col>

        <b-col md="3" style="padding-top: 10px" v-if="caisDetails.suitFiledWillfulDefaultWrittenOffStatus">
          <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
          Suit Filed Wilful Default Written Off Status </span
          ><br />
          <span style="font-size: 12px; color: #5e5873; font-weight: 500">
            {{ caisDetails.suitFiledWillfulDefaultWrittenOffStatus }}
          </span>
        </b-col>
        <b-col md="3" style="padding-top: 10px" v-else>
          <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
          Suit Filed Wilful Default Written Off Status </span
          ><br />
          <span style="font-size: 12px; color: #5e5873; font-weight: 500">
            __ __
          </span>
        </b-col>
        <b-col md="3" style="padding-top: 10px" v-if="caisDetails.suitFiledWilfulDefault">
          <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
          Suit Filed Wilful Default Status </span
          ><br />
          <span style="font-size: 12px; color: #5e5873; font-weight: 500">
            {{ caisDetails.suitFiledWilfulDefault }}
          </span>
        </b-col>
        <b-col md="3" style="padding-top: 10px" v-else>
          <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
          Suit Filed Wilful Default Status </span
          ><br />
          <span style="font-size: 12px; color: #5e5873; font-weight: 500">
            __ __
          </span>
        </b-col>

        <b-col md="3" style="padding-top: 10px" v-if="caisDetails.writtenoffSettledStatus">
          <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
          Written off Settled Status </span
          ><br />
          <span style="font-size: 12px; color: #5e5873; font-weight: 500">
            {{ caisDetails.writtenoffSettledStatus }}
          </span>
        </b-col>
        <b-col md="3" style="padding-top: 10px" v-else>
          <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
          Written off Settled Status </span
          ><br />
          <span style="font-size: 12px; color: #5e5873; font-weight: 500">
            __ __
          </span>
        </b-col>

        <b-col md="3" style="padding-top: 10px" v-if="caisDetails.valueofCreditsLastMonth">
          <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
          Value of Credits Last Month </span
          ><br />
          <span style="font-size: 12px; color: #5e5873; font-weight: 500">
            {{ caisDetails.valueofCreditsLastMonth }}
          </span>
        </b-col>
        <b-col md="3" style="padding-top: 10px" v-else>
          <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
          Value of Credits Last Month </span
          ><br />
          <span style="font-size: 12px; color: #5e5873; font-weight: 500">
            __ __
          </span>
        </b-col>

        <b-col md="3" style="padding-top: 10px" v-if="caisDetails.settlementAmount">
          <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
          Settlement Amount </span
          ><br />
          <span style="font-size: 12px; color: #5e5873; font-weight: 500">
            {{ caisDetails.settlementAmount }}
          </span>
        </b-col>
        <b-col md="3" style="padding-top: 10px" v-else>
          <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
          Settlement Amount </span
          ><br />
          <span style="font-size: 12px; color: #5e5873; font-weight: 500">
            __ __
          </span>
        </b-col>

        <b-col md="3" style="padding-top: 10px" v-if="caisDetails.valueofCollateral">
          <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
          Value of Collateral </span
          ><br />
          <span style="font-size: 12px; color: #5e5873; font-weight: 500">
            {{ caisDetails.valueofCollateral }}
          </span>
        </b-col>
        <b-col md="3" style="padding-top: 10px" v-else>
          <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
          Value of Collateral </span
          ><br />
          <span style="font-size: 12px; color: #5e5873; font-weight: 500">
            __ __
          </span>
        </b-col>

        <b-col md="3" style="padding-top: 10px" v-if="caisDetails.typeofCollateral">
          <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
          Type of Collateral </span
          ><br />
          <span style="font-size: 12px; color: #5e5873; font-weight: 500">
            {{ caisDetails.typeofCollateral }}
          </span>
        </b-col>
        <b-col md="3" style="padding-top: 10px" v-else>
          <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
          Type of Collateral </span
          ><br />
          <span style="font-size: 12px; color: #5e5873; font-weight: 500">
          __ __
          </span>
        </b-col>

        <b-col md="3" style="padding-top: 10px" v-if="caisDetails.writtenOffAmtTotal">
          <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
          Written off Amt Total </span
          ><br />
          <span style="font-size: 12px; color: #5e5873; font-weight: 500">
            {{ caisDetails.writtenOffAmtTotal }}
          </span>
        </b-col>
        <b-col md="3" style="padding-top: 10px" v-else>
          <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
          Written off Amt Total </span
          ><br />
          <span style="font-size: 12px; color: #5e5873; font-weight: 500">
            __ __
          </span>
        </b-col>

        <b-col md="3" style="padding-top: 10px" v-if="caisDetails.writtenOffAmtPrincipal">
          <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
          Written off Amt Principal </span
          ><br />
          <span style="font-size: 12px; color: #5e5873; font-weight: 500">
            {{ caisDetails.writtenOffAmtPrincipal }}
          </span>
        </b-col>
        <b-col md="3" style="padding-top: 10px" v-else>
          <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
          Written off Amt Principal </span
          ><br />
          <span style="font-size: 12px; color: #5e5873; font-weight: 500">
            __ __
          </span>
        </b-col>

        <b-col md="3" style="padding-top: 10px" v-if="caisDetails.writeOffStatusDate">
          <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
        Write off Status Date </span
          ><br />
          <span style="font-size: 12px; color: #5e5873; font-weight: 500">
            {{ caisDetails.writeOffStatusDate }}
          </span>
        </b-col>
        <b-col md="3" style="padding-top: 10px" v-else>
          <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
        Write off Status Date </span
          ><br />
          <span style="font-size: 12px; color: #5e5873; font-weight: 500">
            __ __
          </span>
        </b-col>

        <b-col md="3" style="padding-top: 10px" v-if="caisDetails.income">
          <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
            Income </span
          ><br />
          <span style="font-size: 12px; color: #5e5873; font-weight: 500">
            {{ caisDetails.income }}
          </span>
        </b-col>
        <b-col md="3" style="padding-top: 10px" v-else>
          <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
            Income </span
          ><br />
          <span style="font-size: 12px; color: #5e5873; font-weight: 500">
            __ __
          </span>
        </b-col>

        <b-col md="3" style="padding-top: 10px" v-if="caisDetails.incomeIndicator">
          <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
            Income Indicator </span
          ><br />
          <span style="font-size: 12px; color: #5e5873; font-weight: 500">
            {{ caisDetails.incomeIndicator }}
          </span>
        </b-col>
        <b-col md="3" style="padding-top: 10px" v-else>
          <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
            Income Indicator </span
          ><br />
          <span style="font-size: 12px; color: #5e5873; font-weight: 500">
            __ __
          </span>
        </b-col>

        <b-col md="3" style="padding-top: 10px" v-if="caisDetails.incomeFrequencyIndicator">
          <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
            Income Frequency Indicator </span
          ><br />
          <span style="font-size: 12px; color: #5e5873; font-weight: 500">
            {{ caisDetails.incomeFrequencyIndicator }}
          </span>
        </b-col>
        <b-col md="3" style="padding-top: 10px" v-else>
          <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
            Income Frequency Indicator </span
          ><br />
          <span style="font-size: 12px; color: #5e5873; font-weight: 500">
            __ __
          </span>
        </b-col>

        <b-col md="3" style="padding-top: 10px" v-if="caisDetails.dateOfAddition">
          <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
            Date Of Addition </span
          ><br />
          <span style="font-size: 12px; color: #5e5873; font-weight: 500">
            {{ caisDetails.dateOfAddition }}
          </span>
        </b-col>

        <b-col md="3" style="padding-top: 10px" v-else>
          <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
            Date Of Addition </span
          ><br />
          <span style="font-size: 12px; color: #5e5873; font-weight: 500">
            __ __
          </span>
        </b-col>







      </b-row>
      </vx-card>
      <br/>




      <vx-card
     class="pa-6 mt-6"
     style="padding: 10px"
   >
     <!-- <b-row no-gutters>
       <img
         src="../../assets/icons/accountHolderDets.png"
       >
       <span
         style="height: fit-content;margin: auto 8px;color: #5d43dc;font-size: 15px;font-weight: 700;"
       >Account History</span><br>
     </b-row> -->

     <b-row style="border-bottom: 1px solid rgba(194, 183, 251, 1);">
       <span
         class="col-8 w-full"
         style="font-size: 18px; color: #5e5873; font-weight: 500;
   bottom: 10px;"
       >
       <div class="row" style="margin-left: 0px;margin-left: -1rem;">
       <img
         src="../../assets/icons/accountHolderDets.png"
         alt="login"

       />
       <div style="margin-top: 7px;margin-left: 10px;color:#7367F0;">
          Account History
       </div>
       </div>
       </span>

     </b-row>


     <b-row
       no-gutters
       class="mt-4"
       style="margin-top: 20px !important;"
     >
       <div
         style="display: flex;"
         class="mr-1"
       >
         <div
           class="dot"
           style="border: 2px solid rgba(0, 207, 232, 1);"
         />
         <div
           class="mx-2"
           style="color: #6e6b7b;font-size: 15px;font-weight: 600;"
         >
           Standard
         </div>
       </div>
       <div
         style="display: flex;"
         class="mr-1"
       >
         <div
           class="dot"
           style="border: 2px solid rgba(40, 199, 111, 1);"
         />
         <div
           class="mx-2"
           style="color: #6e6b7b;font-size: 15px;font-weight: 600;"
         >
           Substandard
         </div>
       </div>
       <div
         style="display: flex;"
         class="mr-1"
       >
         <div
           class="dot"
           style="border: 2px solid #ff9f43;"
         />
         <div
           class="mx-2"
           style="color: #6e6b7b;font-size: 15px;font-weight: 600;"
         >
           Doubtful
         </div>
       </div>
       <div
         style="display: flex;"
         class="mr-1"
       >
         <div
           class="dot"
           style="border: 2px solid #856ef7;"
         />
         <div
           class="mx-2"
           style="color: #6e6b7b;font-size: 15px;font-weight: 600;"
         >
           Special Mention Account
         </div>
       </div>
       <div
         style="display: flex;"
         class="mr-1"
       >
         <div
           class="dot"
           style="border: 2px solid #ea5455;"
         />
         <div
           class="mx-2"
           style="color: #6e6b7b;font-size: 15px;font-weight: 600;"
         >
           Loss
         </div>
       </div>

       <div
         style="display: flex;"
         class="mr-1"
       >
         <div
           class="dot"
           style="border: 2px solid rgb(93, 88, 108);"
         />
         <div
           class="mx-2"
           style="color: #6e6b7b;font-size: 15px;font-weight: 600;"
         >
           Not Available
         </div>
       </div>
     </b-row>
     <div style="margin-left: -20px;margin-top: 10px;overflow-x: auto;">
    <b-table
      class="no-padding"
      :items="dpdArray"
      :fields="tableFields"
      :foot-clone="false"
      hover

      responsive
      :no-data-text="'No data available'"
      style="white-space: nowrap;text-align:left;"
    >
    <template #cell(year)="data">
      <div style="font-weight: 600;font-family: Montserrat;">{{ data.value }}</div>
    </template>
      <template #cell(jan)="data">
    <div class="dot" style="width: 39px; height: 39px; text-align: center;" :style="{ border: getBorderColor(data.item.assetClassificationJan, data.value) }">
      <div style="margin-top: 7px;font-weight:600;font-family: Montserrat;">{{data.value}}</div>
    </div>

    </template>

    <template #cell(feb)="data">
  <div class="dot" style="width: 39px; height: 39px; text-align: center;" :style="{ border: getBorderColor(data.item.assetClassificationFeb, data.value) }" >
    <div style="margin-top: 7px;font-weight:600;font-family: Montserrat;">{{data.value}}</div>
  </div>

  </template>
  <template #cell(mar)="data">
<div class="dot" style="width: 39px; height: 39px; text-align: center;" :style="{ border: getBorderColor(data.item.assetClassificationMar, data.value) }" >
  <div style="margin-top: 7px;font-weight:600;font-family: Montserrat;">{{data.value}}</div>
</div>
</template>
<template #cell(apr)="data">
<div class="dot" style="width: 39px; height: 39px; text-align: center;" :style="{ border: getBorderColor(data.item.assetClassificationApr, data.value) }" >
<div style="margin-top: 7px;font-weight:600;font-family: Montserrat;">{{data.value}}</div>
</div>

</template>
<template #cell(may)="data">
<div class="dot" style="width: 39px; height: 39px; text-align: center;" :style="{ border: getBorderColor(data.item.assetClassificationMay, data.value) }" >
<div style="margin-top: 7px;font-weight:600;font-family: Montserrat;">{{data.value}}</div>
</div>

</template>
<template #cell(jun)="data">
<div class="dot" style="width: 39px; height: 39px; text-align: center;" :style="{ border: getBorderColor(data.item.assetClassificationJun, data.value) }" >
<div style="margin-top: 7px;font-weight:600;font-family: Montserrat;">{{data.value}}</div>
</div>
</template>
<template #cell(jul)="data">
<div class="dot" style="width: 39px; height: 39px; text-align: center;" :style="{ border: getBorderColor(data.item.assetClassificationJul, data.value) }" >
<div style="margin-top: 7px;font-weight:600;font-family: Montserrat;">{{data.value}}</div>
</div>
</template>
<template #cell(aug)="data">
<div class="dot" style="width: 39px; height: 39px; text-align: center;" :style="{ border: getBorderColor(data.item.assetClassificationAug, data.value) }" >
<div style="margin-top: 7px;font-weight:600;font-family: Montserrat;">{{data.value}}</div>
</div>

</template>
<template #cell(sep)="data">
<div class="dot" style="width: 39px; height: 39px; text-align: center;" :style="{ border: getBorderColor(data.item.assetClassificationSep, data.value) }" >
<div style="margin-top: 7px;font-weight:600;font-family: Montserrat;">{{data.value}}</div>
</div>

</template>
<template #cell(oct)="data">
<div class="dot" style="width: 39px; height: 39px; text-align: center;" :style="{ border: getBorderColor(data.item.assetClassificationOct, data.value) }" >
<div style="margin-top: 7px;font-weight:600;font-family: Montserrat;">{{data.value}}</div>
</div>
</template>
<template #cell(nov)="data">
<div class="dot" style="width: 39px; height: 39px; text-align: center;" :style="{ border: getBorderColor(data.item.assetClassificationNov, data.value) }" >
<div style="margin-top: 7px;font-weight:600;font-family: Montserrat;">{{data.value}}</div>
</div>

</template>
<template #cell(dec)="data">
<div class="dot" style="width: 39px; height: 39px; text-align: center;" :style="{ border: getBorderColor(data.item.assetClassificationDec, data.value) }" >
<div style="margin-top: 7px;font-weight:600;font-family: Montserrat;">{{data.value}}</div>
</div>
</template>
  </b-table>
    <div v-show="!dpdArray.length" class="text-center text-body-1">
      No data available
    </div>
  </div>
   </vx-card>
 </br>



      <vx-card style="padding: 10px">

        <!-- <b-row style="border-bottom: 1px solid rgba(34, 41, 47, 0.125)">
          <span
            class="col-8 p-2 w-full"
            style="font-size: 16px; color: #5e5873; font-weight: 500"
          >
            CAIS Account Holder Details
          </span>

        </b-row> -->

        <b-row style="border-bottom: 1px solid rgba(194, 183, 251, 1);">
          <span
            class="col-8 w-full"
            style="font-size: 18px; color: #5e5873; font-weight: 500;
      bottom: 10px;"
          >
          <div class="row" style="margin-left: 0px;margin-left: -1rem;">
          <img
            src="../../assets/icons/accountHolderDets.png"
            alt="login"

          />
          <div style="margin-top: 7px;margin-left: 10px;color:#7367F0;">
             Account Holder Details
          </div>
          </div>
          </span>

        </b-row>

        <b-row
          style="
            border-bottom: 1px solid #ebe9f1;
            padding-top: 28px;
            padding-bottom: 28px;
            margin-left: -30px;
          "
          v-if="caisDetails.cAISHolderDetails"
          v-for="caisDets in caisDetails.cAISHolderDetails"
        >
          <b-col md="3" v-if="caisDets.firstName">
            <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
              First Name </span
            ><br />
            <span style="font-size: 12px; color: #5e5873; font-weight: 500">
              {{ caisDets.firstName }}
            </span>
          </b-col>

          <b-col md="3" v-else>
            <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
              First Name </span
            ><br />
            <span style="font-size: 12px; color: #5e5873; font-weight: 500">
              __ __
            </span>
          </b-col>

          <b-col md="3" v-if="caisDets.middleName1">
            <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
              Middle Name 1 </span
            ><br />
            <span style="font-size: 12px; color: #5e5873; font-weight: 500">
              {{ caisDets.middleName1 }}
            </span>
          </b-col>
          <b-col md="3" v-else>
            <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
              Middle Name 1 </span
            ><br />
            <span style="font-size: 12px; color: #5e5873; font-weight: 500">
              __ __
            </span>
          </b-col>
          <b-col md="3" v-if="caisDets.middleName2">
            <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
              Middle Name 2 </span
            ><br />
            <span style="font-size: 12px; color: #5e5873; font-weight: 500">
              {{ caisDets.middleName2 }}
            </span>
          </b-col>
          <b-col md="3" v-else>
            <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
              Middle Name 2 </span
            ><br />
            <span style="font-size: 12px; color: #5e5873; font-weight: 500">
              __ __
            </span>
          </b-col>
          <b-col md="3" v-if="caisDets.surname">
            <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
              Last Name </span
            ><br />
            <span style="font-size: 12px; color: #5e5873; font-weight: 500">
              {{ caisDets.surname }}
            </span>
          </b-col>
          <b-col md="3" v-else>
            <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
              Last Name </span
            ><br />
            <span style="font-size: 12px; color: #5e5873; font-weight: 500">
              __ __
            </span>
          </b-col>


          <b-col md="3" style="padding-top: 10px" v-if="caisDets.gender">
            <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
              Gender </span
            ><br />
            <span style="font-size: 12px; color: #5e5873; font-weight: 500">
                {{ caisDets.gender  }}
            </span>
          </b-col>
          <b-col md="3" style="padding-top: 10px" v-else>
            <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
              Gender </span
            ><br />
            <span style="font-size: 12px; color: #5e5873; font-weight: 500">
                __ __
            </span>
          </b-col>

          <b-col md="3" style="padding-top: 10px" v-if="caisDets.incomeTAXPAN">
            <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
              PAN </span
            ><br />
            <span style="font-size: 12px; color: #5e5873; font-weight: 500">
              {{ caisDets.incomeTAXPAN }}
            </span>
          </b-col>
          <b-col md="3" style="padding-top: 10px" v-else>
            <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
              PAN </span
            ><br />
            <span style="font-size: 12px; color: #5e5873; font-weight: 500">
              __ __
            </span>
          </b-col>

          <b-col md="3" style="padding-top: 10px" v-if="caisDets.dateofbirth">
            <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
              DOB </span
            ><br />
            <span style="font-size: 12px; color: #5e5873; font-weight: 500">
              {{ caisDets.dateofbirth | moment("YYYY-MM-DD") }}
            </span>
          </b-col>
          <b-col md="3" style="padding-top: 10px" v-else>
            <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
              DOB </span
            ><br />
            <span style="font-size: 12px; color: #5e5873; font-weight: 500">
              __ __
            </span>
          </b-col>




        </b-row>

        <b-row
          style="
            border-bottom: 1px solid #ebe9f1;
            padding-top: 28px;
            padding-bottom: 28px;
            margin-left: -30px;
          "
        v-else
        >


          <b-col md="3" >
            <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
              First Name </span
            ><br />
            <span style="font-size: 12px; color: #5e5873; font-weight: 500">
              __ __
            </span>
          </b-col>


          <b-col md="3" >
            <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
              Middle Name 1 </span
            ><br />
            <span style="font-size: 12px; color: #5e5873; font-weight: 500">
              __ __
            </span>
          </b-col>

          <b-col md="3" >
            <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
              Middle Name 2 </span
            ><br />
            <span style="font-size: 12px; color: #5e5873; font-weight: 500">
              __ __
            </span>
          </b-col>

          <b-col md="3" >
            <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
              Last Name </span
            ><br />
            <span style="font-size: 12px; color: #5e5873; font-weight: 500">
              __ __
            </span>
          </b-col>



          <b-col md="3" style="padding-top: 10px" >
            <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
              Gender </span
            ><br />
            <span style="font-size: 12px; color: #5e5873; font-weight: 500">
                __ __
            </span>
          </b-col>


          <b-col md="3" style="padding-top: 10px" >
            <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
              PAN </span
            ><br />
            <span style="font-size: 12px; color: #5e5873; font-weight: 500">
              __ __
            </span>
          </b-col>


          <b-col md="3" style="padding-top: 10px" >
            <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
              DOB </span
            ><br />
            <span style="font-size: 12px; color: #5e5873; font-weight: 500">
              __ __
            </span>
          </b-col>




        </b-row>
        </vx-card>

      </br>


        <vx-card style="padding: 10px">

          <!-- <b-row style="border-bottom: 1px solid rgba(34, 41, 47, 0.125)">
            <span
              class="col-8 p-2 w-full"
              style="font-size: 16px; color: #5e5873; font-weight: 500"
            >
              CAIS Account Holder Address Details
            </span>

          </b-row> -->


          <b-row style="border-bottom: 1px solid rgba(194, 183, 251, 1);">
            <span
              class="col-8 w-full"
              style="font-size: 18px; color: #5e5873; font-weight: 500;
        bottom: 10px;"
            >
            <div class="row" style="margin-left: 0px;margin-left: -1rem;">
            <img
              src="../../assets/icons/accountHolderAdd.png"
              alt="login"

            />
            <div style="margin-top: 7px;margin-left: 10px;color:#7367F0;">
            Account Holder Address Details
            </div>
            </div>
            </span>

          </b-row>

          <b-row style="margin-top: 10px;margin-bottom:10px;">


          </b-row>

          <b-row
            style="padding: 10px;background:rgba(103, 74, 245, 0.08);margin-bottom: 15px;border-radius: 5px;"
            v-if="caisDetails.cAISHolderAddressDetails"
            v-for="(caisDetsAdd,index) in AddressDetails"
          >
          <span
            class="col-12 w-full"
            style="font-size: 16px; color:#7367F0; font-weight: 600;margin-bottom:10px;"
          >
          Address {{index + 1}}
          </span>
            <b-col md="2" v-if="caisDetsAdd.firstLineOfAddress">
              <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
                Address Line 1 </span
              ><br />
              <span style="font-size: 12px; color: #5e5873; font-weight: 500">
                {{ caisDetsAdd.firstLineOfAddress }}
              </span>
            </b-col>
            <b-col md="2" v-else>
              <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
                Address Line 1 </span
              ><br />
              <span style="font-size: 12px; color: #5e5873; font-weight: 500">
                __ __
              </span>
            </b-col>
            <b-col md="2" v-if="caisDetsAdd.secondLineOfAddress">
              <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
                Address Line 2 </span
              ><br />
              <span style="font-size: 12px; color: #5e5873; font-weight: 500">
                {{ caisDetsAdd.secondLineOfAddress }}
              </span>
            </b-col>
            <b-col md="2" v-else>
              <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
                Address Line 2 </span
              ><br />
              <span style="font-size: 12px; color: #5e5873; font-weight: 500">
              __ __
              </span>
            </b-col>




            <b-col md="2" v-if="caisDetsAdd.thirdLineOfAddress">
              <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
                Address Line 3 </span
              ><br />
              <span style="font-size: 12px; color: #5e5873; font-weight: 500">
                  {{ caisDetsAdd.thirdLineOfAddress  }}
              </span>
            </b-col>
            <b-col md="2" v-else>
              <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
                Address Line 3 </span
              ><br />
              <span style="font-size: 12px; color: #5e5873; font-weight: 500">
              __ __
              </span>
            </b-col>


            <b-col md="2" style="border-right: 1px solid rgb(194, 183, 251); padding-right: 10px;">
              <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
                 </span
              ><br />
              <span style="font-size: 12px; color: #5e5873; font-weight: 500">

              </span>
            </b-col>



            <b-col md="2" v-if="caisDetsAdd.telephoneNumber">
              <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
                Telephone Number </span
              ><br />
              <span style="font-size: 12px; color: #5e5873; font-weight: 500">
                  {{ caisDetsAdd.telephoneNumber  }}
              </span>
            </b-col>
            <b-col md="2" v-else>
              <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
                Telephone Number </span
              ><br />
              <span style="font-size: 12px; color: #5e5873; font-weight: 500">
              __ __
              </span>
            </b-col>


            <b-col md="2" v-if="caisDetsAdd.telephoneType">
              <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
                Telephone Type </span
              ><br />
              <span style="font-size: 12px; color: #5e5873; font-weight: 500" v-if="caisDetsAdd.telephoneType === '01'">
                Mobile Phone
              </span>
              <span style="font-size: 12px; color: #5e5873; font-weight: 500" v-else-if="caisDetsAdd.telephoneType === '00'">
                Unknown
              </span>
              <span style="font-size: 12px; color: #5e5873; font-weight: 500" v-else-if="caisDetsAdd.telephoneType === '02'">
                Home Phone
              </span>
              <span style="font-size: 12px; color: #5e5873; font-weight: 500" v-else-if="caisDetsAdd.telephoneType === '03'">
                Office Phone
              </span>
            </b-col>
            <b-col md="2" v-else>
              <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
                Telephone Type </span
              ><br />
              <span style="font-size: 12px; color: #5e5873; font-weight: 500">
              __ __
              </span>
            </b-col>

            <b-col md="2" style="padding-top:10px;" v-if="caisDetsAdd.city">
              <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
                City </span
              ><br />
              <span style="font-size: 12px; color: #5e5873; font-weight: 500">
                {{ caisDetsAdd.city }}
              </span>
            </b-col>

            <b-col md="2" style="" v-else>
              <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
                City </span
              ><br />
              <span style="font-size: 12px; color: #5e5873; font-weight: 500">
                __ __
              </span>
            </b-col>

            <b-col md="2" style="padding-top: 10px" v-if="caisDetsAdd.zIPPostalCode">
              <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
                Pin Code </span
              ><br />
              <span style="font-size: 12px; color: #5e5873; font-weight: 500">
                {{ caisDetsAdd.zIPPostalCode }}
              </span>
            </b-col>
            <b-col md="2" style="padding-top: 10px" v-else>
              <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
                Pin Code </span
              ><br />
              <span style="font-size: 12px; color: #5e5873; font-weight: 500">
                __ __
              </span>
            </b-col>

            <b-col md="2" style="padding-top: 10px" v-if="caisDetsAdd.state">
              <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
                State </span
              ><br />
              <span style="font-size: 12px; color: #5e5873; font-weight: 500" v-if="caisDetsAdd.state === '01'">
                JAMMU and KASHMIR
              </span>
              <span style="font-size: 12px; color: #5e5873; font-weight: 500" v-else-if="caisDetsAdd.state === '02'">
                HIMACHAL PRADESH
              </span>
              <span style="font-size: 12px; color: #5e5873; font-weight: 500" v-else-if="caisDetsAdd.state === '03'">
                PUNJAB
              </span>
              <span style="font-size: 12px; color: #5e5873; font-weight: 500" v-else-if="caisDetsAdd.state === '04'">
                CHANDIGARH
              </span>
              <span style="font-size: 12px; color: #5e5873; font-weight: 500" v-else-if="caisDetsAdd.state === '05'">
                UTTRANCHAL
              </span>
              <span style="font-size: 12px; color: #5e5873; font-weight: 500" v-else-if="caisDetsAdd.state === '06'">
                HARAYANA
              </span>
              <span style="font-size: 12px; color: #5e5873; font-weight: 500" v-else-if="caisDetsAdd.state === '07'">
                DELHI
              </span>
              <span style="font-size: 12px; color: #5e5873; font-weight: 500" v-else-if="caisDetsAdd.state === '08'">
                RAJASTHAN
              </span>
              <span style="font-size: 12px; color: #5e5873; font-weight: 500" v-else-if="caisDetsAdd.state === '09'">
                UTTAR PRADESH
              </span>
              <span style="font-size: 12px; color: #5e5873; font-weight: 500" v-else-if="caisDetsAdd.state === '10'">
                BIHAR
              </span>
              <span style="font-size: 12px; color: #5e5873; font-weight: 500" v-else-if="caisDetsAdd.state === '11'">
                SIKKIM
              </span>
              <span style="font-size: 12px; color: #5e5873; font-weight: 500" v-else-if="caisDetsAdd.state === '12'">
                ARUNACHAL PRADESH
              </span>
              <span style="font-size: 12px; color: #5e5873; font-weight: 500" v-else-if="caisDetsAdd.state === '13'">
                NAGALAND
              </span>
              <span style="font-size: 12px; color: #5e5873; font-weight: 500" v-else-if="caisDetsAdd.state === '14'">
                MANIPUR
              </span>
              <span style="font-size: 12px; color: #5e5873; font-weight: 500" v-else-if="caisDetsAdd.state === '15'">
                MIZORAM
              </span>
              <span style="font-size: 12px; color: #5e5873; font-weight: 500" v-else-if="caisDetsAdd.state === '16'">
                TRIPURA
              </span>
              <span style="font-size: 12px; color: #5e5873; font-weight: 500" v-else-if="caisDetsAdd.state === '17'">
                MEGHALAYA
              </span>
              <span style="font-size: 12px; color: #5e5873; font-weight: 500" v-else-if="caisDetsAdd.state === '18'">
                ASSAM
              </span>
              <span style="font-size: 12px; color: #5e5873; font-weight: 500" v-else-if="caisDetsAdd.state === '19'">
                WEST BENGAL
              </span>
              <span style="font-size: 12px; color: #5e5873; font-weight: 500" v-else-if="caisDetsAdd.state === '20'">
                JHARKHAND
              </span>
              <span style="font-size: 12px; color: #5e5873; font-weight: 500" v-else-if="caisDetsAdd.state === '21'">
                ORRISA
              </span>
              <span style="font-size: 12px; color: #5e5873; font-weight: 500" v-else-if="caisDetsAdd.state === '22'">
                CHHATTISGARH
              </span>
              <span style="font-size: 12px; color: #5e5873; font-weight: 500" v-else-if="caisDetsAdd.state === '23'">
                MADHYA PRADESH
              </span>
              <span style="font-size: 12px; color: #5e5873; font-weight: 500" v-else-if="caisDetsAdd.state === '24'">
                GUJRAT
              </span>
              <span style="font-size: 12px; color: #5e5873; font-weight: 500" v-else-if="caisDetsAdd.state === '25'">
                DAMAN and DIU
              </span>
              <span style="font-size: 12px; color: #5e5873; font-weight: 500" v-else-if="caisDetsAdd.state === '26'">
                DADARA and NAGAR HAVELI
              </span>
              <span style="font-size: 12px; color: #5e5873; font-weight: 500" v-else-if="caisDetsAdd.state === '27'">
                MAHARASHTRA
              </span>
              <span style="font-size: 12px; color: #5e5873; font-weight: 500" v-else-if="caisDetsAdd.state === '28'">
                ANDHRA PRADESH
              </span>
              <span style="font-size: 12px; color: #5e5873; font-weight: 500" v-else-if="caisDetsAdd.state === '29'">
                KARNATAKA
              </span>
              <span style="font-size: 12px; color: #5e5873; font-weight: 500" v-else-if="caisDetsAdd.state === '30'">
                GOA
              </span>
              <span style="font-size: 12px; color: #5e5873; font-weight: 500" v-else-if="caisDetsAdd.state === '31'">
                LAKSHADWEEP
              </span>
              <span style="font-size: 12px; color: #5e5873; font-weight: 500" v-else-if="caisDetsAdd.state === '32'">
                KERALA
              </span>
              <span style="font-size: 12px; color: #5e5873; font-weight: 500" v-else-if="caisDetsAdd.state === '33'">
                TAMIL NADU
              </span>
              <span style="font-size: 12px; color: #5e5873; font-weight: 500" v-else-if="caisDetsAdd.state === '34'">
              PONDICHERRY
              </span>
              <span style="font-size: 12px; color: #5e5873; font-weight: 500" v-else-if="caisDetsAdd.state === '35'">
              ANDAMAN and NICOBAR ISLANDS
              </span>
              <span style="font-size: 12px; color: #5e5873; font-weight: 500" v-else-if="caisDetsAdd.state === '36'">
              Telangana
              </span>
            </b-col>

            <b-col md="2" style="padding-top: 10px" v-else>
              <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
                State </span
              ><br />
              <span style="font-size: 12px; color: #5e5873; font-weight: 500">
                __ __
              </span>
            </b-col>


            <b-col md="2" style="padding-top: 10px;border-right: 1px solid rgb(194, 183, 251); padding-right: 10px;" v-if="caisDetsAdd.countryCode">
              <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
                Country </span
              ><br />
              <span style="font-size: 12px; color: #5e5873; font-weight: 500">
                India
              </span>
            </b-col>
            <b-col md="2" style="padding-top: 10px" v-else>
              <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
                Country </span
              ><br />
              <span style="font-size: 12px; color: #5e5873; font-weight: 500">
                __ __
              </span>
            </b-col>


            <b-col md="2" style="padding-top: 10px" v-if="caisDetsAdd.telephoneExtension">
              <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
                Telephone Extension </span
              ><br />
              <span style="font-size: 12px; color: #5e5873; font-weight: 500">
                {{caisDetsAdd.telephoneExtension}}
              </span>
            </b-col>
            <b-col md="2" style="padding-top: 10px" v-else>
              <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
                Telephone Extension </span
              ><br />
              <span style="font-size: 12px; color: #5e5873; font-weight: 500">
                __ __
              </span>
            </b-col>


            <b-col md="2" style="padding-top: 10px" v-if="caisDetsAdd.mobileTelephoneNumber">
              <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
                Mobile Telephone Number </span
              ><br />
              <span style="font-size: 12px; color: #5e5873; font-weight: 500">
                {{caisDetsAdd.mobileTelephoneNumber}}
              </span>
            </b-col>
            <b-col md="2" style="padding-top: 10px" v-else>
              <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
                Mobile Telephone Number </span
              ><br />
              <span style="font-size: 12px; color: #5e5873; font-weight: 500">
                __ __
              </span>
            </b-col>

            <b-col md="2" style="padding-top: 10px" v-if="caisDetsAdd.residencecode">
              <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
                Residence Type </span
              ><br />
              <span style="font-size: 12px; color: #5e5873; font-weight: 500" v-if="caisDetsAdd.residencecode === '01'">
                Owned
              </span>
              <span style="font-size: 12px; color: #5e5873; font-weight: 500" v-if="caisDetsAdd.residencecode === '02'">
                Rented
              </span>
            </b-col>

            <b-col md="2" style="padding-top: 10px" v-else>
              <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
                Residence Type </span
              ><br />
              <span style="font-size: 12px; color: #5e5873; font-weight: 500">
                __ __
              </span>
            </b-col>

            <b-col md="2" style="padding-top: 10px" v-if="caisDetsAdd.addressindicator">
              <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
                Address Type </span
              ><br />
              <span style="font-size: 12px; color: #5e5873; font-weight: 500" v-if="caisDetsAdd.addressindicator === '01'">
                Permanent address
              </span>
              <span style="font-size: 12px; color: #5e5873; font-weight: 500" v-else-if="caisDetsAdd.addressindicator === '02'">
                Residence Address
              </span>
              <span style="font-size: 12px; color: #5e5873; font-weight: 500" v-else-if="caisDetsAdd.addressindicator === '03'">
                Office Address
              </span>
              <span style="font-size: 12px; color: #5e5873; font-weight: 500" v-else-if="caisDetsAdd.addressindicator === '04'">
                Not Categorised
              </span>
            </b-col>

            <b-col md="2" style="padding-top: 10px" v-else>
              <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
                Address Type </span
              ><br />
              <span style="font-size: 12px; color: #5e5873; font-weight: 500">
                __ __
              </span>
            </b-col>


            <b-col md="2" style="padding-top: 10px;">
              <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
                 </span
              ><br />
              <span style="font-size: 12px; color: #5e5873; font-weight: 500">

              </span>
            </b-col>

            <b-col md="2" style="padding-top: 10px;border-right: 1px solid rgb(194, 183, 251); padding-right: 10px;">
              <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
                 </span
              ><br />
              <span style="font-size: 12px; color: #5e5873; font-weight: 500">

              </span>
            </b-col>

            <b-col md="2" style="padding-top: 10px">
              <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
                 </span
              ><br />
              <span style="font-size: 12px; color: #5e5873; font-weight: 500">

              </span>
            </b-col>







          </b-row>



          <b-row
            style="margin-left: -30px;"
            v-else
          >

            <b-col md="3" >
              <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
                Address Line 1 </span
              ><br />
              <span style="font-size: 12px; color: #5e5873; font-weight: 500">
                __ __
              </span>
            </b-col>

            <b-col md="3" >
              <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
                Address Line 2 </span
              ><br />
              <span style="font-size: 12px; color: #5e5873; font-weight: 500">
              __ __
              </span>
            </b-col>



            <b-col md="3" >
              <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
                Address Line 3 </span
              ><br />
              <span style="font-size: 12px; color: #5e5873; font-weight: 500">
              __ __
              </span>
            </b-col>



            <b-col md="3" style="" >
              <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
                City </span
              ><br />
              <span style="font-size: 12px; color: #5e5873; font-weight: 500">
                __ __
              </span>
            </b-col>


            <b-col md="3" style="padding-top: 10px" >
              <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
                Pin Code </span
              ><br />
              <span style="font-size: 12px; color: #5e5873; font-weight: 500">
                __ __
              </span>
            </b-col>



            <b-col md="3" style="padding-top: 10px">
              <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
                State </span
              ><br />
              <span style="font-size: 12px; color: #5e5873; font-weight: 500">
                __ __
              </span>
            </b-col>



            <b-col md="3" style="padding-top: 10px" >
              <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
                Country </span
              ><br />
              <span style="font-size: 12px; color: #5e5873; font-weight: 500">
                __ __
              </span>
            </b-col>



            <b-col md="3" style="padding-top: 10px" >
              <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
                Residence Type </span
              ><br />
              <span style="font-size: 12px; color: #5e5873; font-weight: 500">
                __ __
              </span>
            </b-col>



            <b-col md="3" style="padding-top: 10px" >
              <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
                Address Type </span
              ><br />
              <span style="font-size: 12px; color: #5e5873; font-weight: 500">
                __ __
              </span>
            </b-col>




          </b-row>

          <!-- <b-row style="margin-top: 10px;margin-bottom:10px;">
            <span
              class="col-6 w-full"
              style="font-size: 16px; color: #5E5873; font-weight: 600;margin-left: -1rem;"
            >
              Phone Details

            </span>

          </b-row>

          <b-row
          style="margin-left: -30px;"
          v-if = "caisDetails.cAISHolderPhoneDetails"
          v-for="caisDetsPh in caisDetails.cAISHolderPhoneDetails"
          >
            <b-col md="3" v-if="caisDetsPh.telephoneNumber">
              <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
                Telephone Number </span
              ><br />
              <span style="font-size: 12px; color: #5e5873; font-weight: 500">
                {{ caisDetsPh.telephoneNumber }}
              </span>
            </b-col>
            <b-col md="3" v-else>
              <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
                Telephone Number </span
              ><br />
              <span style="font-size: 12px; color: #5e5873; font-weight: 500">
                __ __
              </span>
            </b-col>
            <b-col md="3" v-if="caisDetsPh.telephoneType">
              <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
                Telephone Type </span
              ><br />
              <span style="font-size: 12px; color: #5e5873; font-weight: 500" v-if="caisDetsPh.telephoneType === '01'">
                Mobile Phone
              </span>
              <span style="font-size: 12px; color: #5e5873; font-weight: 500" v-else-if="caisDetsPh.telephoneType === '00'">
                Unknown
              </span>
              <span style="font-size: 12px; color: #5e5873; font-weight: 500" v-else-if="caisDetsPh.telephoneType === '02'">
                Home Phone
              </span>
              <span style="font-size: 12px; color: #5e5873; font-weight: 500" v-else-if="caisDetsPh.telephoneType === '03'">
                Office Phone
              </span>
            </b-col>

            <b-col md="3" v-else>
              <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
                Telephone Type </span
              ><br />
              <span style="font-size: 12px; color: #5e5873; font-weight: 500">
                __ __
              </span>
            </b-col>


            <b-col md="3" v-if="caisDetsPh.telephoneExtension">
              <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
                Telephone Extension </span
              ><br />
              <span style="font-size: 12px; color: #5e5873; font-weight: 500">
                  {{ caisDetsPh.telephoneExtension  }}
              </span>
            </b-col>

            <b-col md="3" v-else>
              <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
                Telephone Extension </span
              ><br />
              <span style="font-size: 12px; color: #5e5873; font-weight: 500">
                  __ __
              </span>
            </b-col>

            <b-col md="3" style="" v-if="caisDetsPh.mobileTelephoneNumber">
              <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
                Mobile Telephone Number </span
              ><br />
              <span style="font-size: 12px; color: #5e5873; font-weight: 500">
                {{ caisDetsPh.mobileTelephoneNumber }}
              </span>
            </b-col>

            <b-col md="3" style="" v-else>
              <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
                Mobile Telephone Number </span
              ><br />
              <span style="font-size: 12px; color: #5e5873; font-weight: 500">
                __ __
              </span>
            </b-col>





          </b-row>


          <b-row
          style="margin-left: -30px;"
          v-else
          >

            <b-col md="3">
              <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
                Telephone Number </span
              ><br />
              <span style="font-size: 12px; color: #5e5873; font-weight: 500">
                __ __
              </span>
            </b-col>


            <b-col md="3" >
              <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
                Telephone Type </span
              ><br />
              <span style="font-size: 12px; color: #5e5873; font-weight: 500">
                __ __
              </span>
            </b-col>




            <b-col md="3" >
              <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
                Telephone Extension </span
              ><br />
              <span style="font-size: 12px; color: #5e5873; font-weight: 500">
                  __ __
              </span>
            </b-col>



            <b-col md="3" style="" >
              <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
                Mobile Telephone Number </span
              ><br />
              <span style="font-size: 12px; color: #5e5873; font-weight: 500">
                __ __
              </span>
            </b-col>





          </b-row> -->


          </vx-card>





      <!-- <vx-card >
      <div>
      <div style="padding-top: 27px">
        <b-row style="border-bottom: 1px solid rgba(34, 41, 47, 0.125)">
          <span
            class="col-8 p-2 w-full"
            style="font-size: 18px; color: #5e5873; font-weight: 500"
          >
          Current Application Details
          </span>








        </b-row>




        <b-row
          style="
            border-bottom: 1px solid #ebe9f1;
            padding-top: 16px;
            padding-bottom: 8px;
          "

        >
          <b-col md="3" style="padding-top: 10px">
            <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
              Enquiry Reason</span
            ><br />
            <span style="font-size: 12px; color: #5e5873; font-weight: 500">
              {{ currentApplicationDetails.enquiryReason }}
            </span>
          </b-col>
          <b-col md="3" style="padding-top: 10px">
            <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
               Finance Purpose </span
            ><br />
            <span style="font-size: 12px; color: #5e5873; font-weight: 500">
              {{ currentApplicationDetails.financialPurpose }}
            </span>
          </b-col>

          <b-col md="3" style="padding-top: 10px">
            <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
              First Name </span
            ><br />
            <span style="font-size: 12px; color: #5e5873; font-weight: 500">
              {{ currentApplicationDetails.firstName }}
            </span>
          </b-col>

          <b-col md="3" style="padding-top: 10px">
            <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
              Last Name </span
            ><br />
            <span style="font-size: 12px; color: #5e5873; font-weight: 500">
              {{ currentApplicationDetails.surname }}
            </span>
          </b-col>
          <b-col md="3" style="padding-top: 10px">
            <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
              Gender </span
            ><br />
            <span style="font-size: 12px; color: #5e5873; font-weight: 500">
              {{ currentApplicationDetails.gender }}
            </span>
          </b-col>
          <b-col md="3" style="padding-top: 10px">
            <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
              DOB </span
            ><br />
            <span style="font-size: 12px; color: #5e5873; font-weight: 500">
              {{ currentApplicationDetails.dateOfBirth }}
            </span>
          </b-col>

          <b-col md="3" style="padding-top: 10px">
            <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
              Mobile Number </span
            ><br />
            <span style="font-size: 12px; color: #5e5873; font-weight: 500">
              {{ currentApplicationDetails.phoneNumber }}
            </span>
          </b-col>

          <b-col md="3" style="padding-top: 10px">
            <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
              Address </span
            ><br />
            <span style="font-size: 12px; color: #5e5873; font-weight: 500">
              {{ currentApplicationDetails.firstLineAddress }}
            </span>
          </b-col>

          <b-col md="3" style="padding-top: 10px">
            <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
              City </span
            ><br />
            <span style="font-size: 12px; color: #5e5873; font-weight: 500">
              {{currentApplicationDetails.city}}
            </span>
          </b-col>
          <b-col md="3" style="padding-top: 10px">
            <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
              State </span
            ><br />
            <span style="font-size: 12px; color: #5e5873; font-weight: 500">
              {{currentApplicationDetails.state}}
            </span>
          </b-col>


          <b-col md="3" style="padding-top: 10px">
            <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
              Pincode </span
            ><br />
            <span style="font-size: 12px; color: #5e5873; font-weight: 500">
              {{currentApplicationDetails.pinCode}}
            </span>
          </b-col>


          </b-row>
      </div>
      </div>
    </vx-card>


    <br/>
    <vx-card >
    <div>
    <div style="padding-top: 27px">
      <b-row style="border-bottom: 1px solid rgba(34, 41, 47, 0.125)">
        <span
          class="col-8 p-2 w-full"
          style="font-size: 18px; color: #5e5873; font-weight: 500"
        >
        CAIS Summary
        </span>








      </b-row>



      <b-row>
        <span
          class="col-12 p-2 w-full"
          style="font-size: 14px; color: #5e5873; font-weight: 500;
        "
        >
        Credit Account
        </span>



        <b-col md="3">
          <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
            Total Credit Account</span
          ><br />
          <span style="font-size: 12px; color: #5e5873; font-weight: 500">
            {{ caisSummary.caisDetailsTotal }}
          </span>
        </b-col>
        <b-col md="3" >
          <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
             Active Credit Account </span
          ><br />
          <span style="font-size: 12px; color: #5e5873; font-weight: 500">
            {{ caisSummary.caisDetailsActive }}
          </span>
        </b-col>

        <b-col md="3">
          <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
            Default Credit Account </span
          ><br />
          <span style="font-size: 12px; color: #5e5873; font-weight: 500">
            {{ caisSummary.caisDetailsDefault }}
          </span>
        </b-col>

        <b-col md="3" style="padding-top: 10px">
          <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
            Closed Credit Account</span
          ><br />
          <span style="font-size: 12px; color: #5e5873; font-weight: 500">
            {{ caisSummary.caisDetailsClosed }}
          </span>
        </b-col>
        <b-col md="3" style="padding-top: 10px">
          <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
            CAD Suit Filed Current Account </span
          ><br />
          <span style="font-size: 12px; color: #5e5873; font-weight: 500">
            {{ caisSummary.cadSuitFiledCurrentBalance }}
          </span>
        </b-col>

        <span
          class="col-12 p-2 w-full"
          style="font-size: 14px; color: #5e5873; font-weight: 500;"
        >
        Total Outstanding Balance - {{caisSummary.outstandingBalanceAll}}
        </span>
        <b-col md="3">
          <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
            Secured Outstanding Balance </span
          ><br />
          <span style="font-size: 12px; color: #5e5873; font-weight: 500">
            {{ caisSummary.outstandingBalanceSecured }}
          </span>
        </b-col>

        <b-col md="3" >
          <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
            Outstanding Balance Secured% </span
          ><br />
          <span style="font-size: 12px; color: #5e5873; font-weight: 500">
            {{ caisSummary.outstandingBalanceSecuredPercentage }}
          </span>
        </b-col>

        <b-col md="3" style="padding-top: 10px">
          <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
            Unsecured Outstanding Balance </span
          ><br />
          <span style="font-size: 12px; color: #5e5873; font-weight: 500">
          {{ caisSummary.outstandingBalanceUnSecured }}
          </span>
        </b-col>
        <b-col md="3" style="padding-top: 10px">
          <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
            Outstanding Balance Unsecured% </span
          ><br />
          <span style="font-size: 12px; color: #5e5873; font-weight: 500">
            {{ caisSummary.outstandingBalanceUnSecuredPercentage }}
          </span>
        </b-col>





      </b-row>


      <b-row >
        <span
          class="col-12 p-2 w-full"
          style="font-size: 14px; color: #5e5873; font-weight: 500;"
        >
        Total Outstanding Balance
        </span>

      <div class="left">

           <button id="left-button" @click="swipeLeft">
             <img
               style="margin: auto 0px auto auto;"
               src="../../assets/icons/LeftArrowIcon.png"
             />
           </button>
         </div>
          <div class="center" id="content" ref="content">
           <vx-card class="internal"   :style="{ backgroundColor: colorPatter[index] }"  >
            <div style="margin-top:10px;color:white;">CAIS Account {{index}}</div>
           </vx-card>

          </div>
         <div class="right">
         <button id="right-button" @click="swipeRight">
           <img
             style="margin: auto 0px auto auto;"
             src="../../assets/icons/RightArrowIcon.png"
           />
           </button>

         </div>

       </b-row>





    </div>
    </div>
  </vx-card>





  <br/>




<vx-card >
<div>
<div style="padding-top: 27px">
  <b-row style="border-bottom: 1px solid rgba(34, 41, 47, 0.125)">
    <span
      class="col-8 p-2 w-full"
      style="font-size: 18px; color: #5e5873; font-weight: 500"
    >
    CAPS Summary
    </span>








  </b-row>



  <b-row>
    <span
      class="col-12 p-2 w-full"
      style="font-size: 14px; color: #5e5873; font-weight: 500;
    "
    >
    Total CAPS Summary
    </span>



    <b-col md="3">
      <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
        Total CAPS Last 7 Days</span
      ><br />
      <span style="font-size: 12px; color: #5e5873; font-weight: 500">
        {{ capsSummary.cAPSLast7Days }}
      </span>
    </b-col>
    <b-col md="3" >
      <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
         Total CAPS Last 30 Days </span
      ><br />
      <span style="font-size: 12px; color: #5e5873; font-weight: 500">
        {{ capsSummary.cAPSLast30Days }}
      </span>
    </b-col>

    <b-col md="3">
      <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
        Total CAPS Last 90 Days </span
      ><br />
      <span style="font-size: 12px; color: #5e5873; font-weight: 500">
        {{ capsSummary.cAPSLast90Days }}
      </span>
    </b-col>

    <b-col md="3" style="padding-top: 10px">
      <span style="font-size: 12px; color: #b9b9c3; font-weight: 500">
        Total CAPS Last 180 Days</span
      ><br />
      <span style="font-size: 12px; color: #5e5873; font-weight: 500">
        {{ capsSummary.cAPSLast180Days }}
      </span>
    </b-col>


    <span
      class="col-12 p-2 w-full"
      style="font-size: 14px; color: #5e5873; font-weight: 500;"
    >
    Non Credit CAPS
    </span>

  </b-row>





</div>
</div>
</vx-card> -->

  </div>
</template>

<script>
import {
  BBreadcrumb,
  BButton,
  BBreadcrumbItem,
  BCardText,
} from "bootstrap-vue";
import { BRow, BCol } from "bootstrap-vue";
import axios from "axios";
import VueSlickCarousel from 'vue-slick-carousel'
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'
export default {
  data() {
    return {
      leadFlag:true,
      leadDetails:[],
      panDetails:[],
      items: [
        {
          text: "Home",
        },
        {
          text: "Library",
        },
        {
          text: "Data",
          active: true,
        },
      ],
      settings: {
          arrows: true,
          dots: true,
          slidesToShow: 13,
        },
      GeneralError: false,
      GeneralErrorBank: false,
      errorMessageBank: "",
      showVeriFlag: false,
      bankaccHolderName: "",
      defaultStatFlag: 0,
      activeStatFlag: 0,
      deleteStatFlag: "",
      verificatioStatus: false,
      bankName: "",
      bankDetailsSet: [],
      verificationData: [],
      custDetails: [],
      bankaccNo: "",
      accType: "",
      mobileNumber: "",
      fileDownloadUrl:'',
      currentApplicationDetails:[],

      accounType: [
        { text: "Saving", value: "Saving" },
        { text: "Current", value: "Current" },
      ],

      defaultBank: [
        { text: "Yes", value: 1 },
        { text: "No", value: 0 },
      ],
      defaultBankStatus: 1,
      activeBank: [
        { text: "Yes", value: 1 },
        { text: "No", value: 0 },
      ],
      activeBankStatus: 1,
      deleteBank: [
        { text: "Yes", value: 1 },
        { text: "No", value: 0 },
      ],
      deleteBankStatus: 0,
      personalBank: [
        { text: "Yes", value: 1 },
        { text: "No", value: 0 },
      ],
      personalBankStatus: 1,
      accuntFlag: false,
      accErrorFlag: false,
      accNameFlag: false,
      bankNameFlag: false,
      ifscCodeFlag: false,
      branchFlag: false,
      accTypeFlag: false,
      branchValFlag: false,
      branchCityFlag: false,
      branchcityValFlag: false,
      accTypeError: "",
      branchError: "",
      ifscCodeError: "",
      bankNameError: "",
      branchCityError: "",
      colorPatter:["#FE7C00","#28C76F","#005EFF","#4328AE","#97C93E","#FE7C00","#34a4eb","#ab34eb","#d934eb","#eb34b1","#34eb93","#ebe234","#eb9634","#ebc334","#FE7C00","#28C76F","#005EFF","#4328AE","#97C93E","#FE7C00","#34a4eb","#ab34eb","#d934eb","#eb34b1","#34eb93","#ebe234","#eb9634","#ebc334"],
      dpdArray: [], // Your dpdArray data goes here
     tableFields: [
       { key: 'year', label: 'DPD'},
       { key: 'jan', label: 'JAN'},
       { key: 'feb', label: 'FEB' },
       { key: 'mar', label: 'MAR'},
       { key: 'apr', label: 'APR'},
       { key: 'may', label: 'MAY'},
       { key: 'jun', label: 'JUN'},
       { key: 'jul', label: 'JUL'},
       { key: 'aug', label: 'AUG'},
       { key: 'sep', label: 'SEP'},
       { key: 'oct', label: 'OCT'},
       { key: 'nov', label: 'NOV'},
       { key: 'dec', label: 'DEC'},
     ],

      accNameError: "",
      accFlagMessage: "",
      errorMessage: "",
      mailTo: "",
      orderID: "",
      supplierID: "",
      activeTab: "",
      rejectReason: "",
      supplierStatus: "",
      awaitingSupplierDetails: [],
      rejectSupplierDetails: [],
      activeSupplierDetails: [],
      supplierDetails: [],
      rejectPopFlag: false,
      hideButton: false,
      addbankPopFlag: false,
      supplierbankVerifiedFlag: false,
      newBankAccNo: "",

      newAccHolderName: "",
      newBankName: "",
      newIFSCcode: "",
      newBranch: "",
      newMICRCode: "",
      newBranchCity: "",
      newaccType: "",
      supplierBankID: "",
      bankVerifyBtn: "",
      setTotalAmount:'',
      bankSMSPop:false,
      loginID:'',
      max:10,
      rejectReason:'',
      totalActiveLoans:0,
      BureauScore:'',
      bureauScoreConfidLevel:'',
      creditScoreRating:'',
      exactMatch:'',
      totalOutstandingBalance:'',
      caisDetails:[],
      capsSummary:[],
      cAISAccountDetailsList:[],
      caisDetailsposition:'',
      panNumber:'',
      AddressDetails:[],
      phoneDetails:[],
    };
  },

  created() {



    this.caisDetails =  JSON.parse(this.$route.query.caisDets)
    console.log("this is the cais details",JSON.stringify(this.caisDetails))
    this.$store.commit("routeChange", "end");
    this.panNumber = this.$route.query.panNo
    this.getCreditScore();




  },
  computed: {},
  methods: {
    printInvoice() {
      window.print();
    },


    viewLeadData()
    {
      this.$router.push({
        path: "/leadInsuranceDetails",
        query: {panNo: this.$route.query.panNo},
      });

    },
    routeCais(item)
    {
      this.$router.push({
        path: "/leadInsuranceDetails",
        query: {panNo: this.$route.query.panNo},
      });
    },

    dotFormatter(value) {
      console.log("this is the vlaueeeee",value)
      return `
        <div class="dot" style="width: 25px; height: 25px; text-align: center; border: ${this.getBorderColor(value.assetClassification, value)};">
          ${value}
        </div>
      `;
    },
    getBorderColor(assetClassification, value) {

      if(value != "---")
  {
    switch(assetClassification)
    {
    case "S":
      return "2px solid rgba(0, 207, 232, 1)"
    case "B":
      return "2px solid rgba(40, 199, 111, 1)"
    case "D":
      return "2px solid #ff9f43"
    case "M":
      return "2px solid #856ef7"
    case "L":
      return "2px solid #ea5455"
    case "s":
      return "2px solid rgba(0, 207, 232, 1)"
    case "b":
      return "2px solid rgba(40, 199, 111, 1)"
    case "d":
      return "2px solid #ff9f43"
    case "m":
      return "2px solid #856ef7"
    case "l":
      return "2px solid #ea5455"
    default :
      return "2px solid #5d586c"

    }
  }
  else{
    return "2px solid #5d586c"
  }
    },


    fetchPanDetails()
    {





      var self = this
      self.$store.commit("routeChange", "start");

      const instance = axios.create({
              // baseURL: 'https://cors-anywhere.herokuapp.com/http://13.126.29.47:8080/mintLoan/mintloan/', //LIVE
               baseURL: 'https://uatgateway.supermoney.in/tomcat/kycservice/kyc/',
            // baseURL: 'https://cors-anywhere.herokuapp.com/https://uatgateway.supermoney.in/tomcat/mintLoan/mintloan/', //DEV
            // baseURL: 'https://cors-anywhere.herokuapp.com/https://uatgateway.supermoney.in/tomcat/mintLoan/mintloan/', //live
         headers: {'content-type': 'application/json'}
       })


      //  var url = 'http://13.126.28.53:8080/MintReliance/MintReliance/kycCheck'
      var data = {
      client_id : 'arcClientId',
      payload: {
      panNo: self.$route.query.panNo,
      fetchLiveData: true
            },
      request_id: "arcRequestId1",
      requester_id: "ARC",
      service_provider_name: "NIL"


      };
      instance.post('fetchPANV2',data)

      .then(function (response) {
      console.log(response);
      const JSONData = response.data;
      if (JSONData.resp_status === "SUCCESS") {

        self.panDetails = JSONData.payload

        self.getCreditScore()

      }

      else {
      self.panDetails = []
      console.log("display Error"+JSONData.kaleyraError)

      }
      self.$store.commit("routeChange", "end");
      self.progress = false;

      })
      .catch(error => {
      self.errorText = "Network Error";
      console.log("display Error"+error)
      self.$store.commit("routeChange", "end");


      });

    },

    viewCreditData()
    {
      this.$router.push({
        path: "/creditBureauLead",
        query: {panNo: this.$route.query.panNo},
      });
    },




    scrollTo(element, scrollPixels, duration) {
   const scrollPos = element.scrollLeft;
   // Condition to check if scrolling is required
   if ( !( (scrollPos === 0 || scrollPixels > 0) && (element.clientWidth + scrollPos === element.scrollWidth || scrollPixels < 0)))
   {
     // Get the start timestamp
     const startTime =
       "now" in window.performance
         ? performance.now()
         : new Date().getTime();

     function scroll(timestamp) {
       //Calculate the timeelapsed
       const timeElapsed = timestamp - startTime;
       //Calculate progress
       const progress = Math.min(timeElapsed / duration, 1);
       //Set the scrolleft
       element.scrollLeft = scrollPos + scrollPixels * progress;
       //Check if elapsed time is less then duration then call the requestAnimation, otherwise exit
       if (timeElapsed < duration) {
         //Request for animation
         window.requestAnimationFrame(scroll);
       } else {
         return;
       }
     }
     //Call requestAnimationFrame on scroll function first time
     window.requestAnimationFrame(scroll);
   }
 },
 swipeLeft() {
   const content = this.$refs.content;
   this.scrollTo(content, -300, 800);
 },
 swipeRight() {
   const content = this.$refs.content;
   this.scrollTo(content, 300, 800);
 },


    getLeadDetails()
    {
      this.$store.commit("routeChange", "start");
      var self = this;
      var startdate = self.$moment(self.startDate).format("YYYY-MM-DD")
      var enddate = self.$moment(self.endDate).format("YYYY-MM-DD")
      var url =
        "https://uatgateway.supermoney.in/crmbackend/InsuranceLead/?pan_number="+self.$route.query.panNo;
      axios
        .get(url)
        .then(function(response) {
          // handle success

          const JSONData = response.data;
          self.leadDetails = JSONData.data
          self.fetchPanDetails()

          self.$store.commit("routeChange", "end");
        })
        .catch(function(error) {
          // handle error
          console.log("display  ==" + error);
          self.$store.commit("routeChange", "end");
          self.invoiceDetails = [];
        })
        .finally(function() {
          self.$store.commit("routeChange", "end");
          self.invoiceDetails = [];
          // always executed
        });
    },


    getMandate(mandate) {
      console.log("this is mandate id",mandate)
       var self = this
      self.$store.commit("routeChange", "start");
      console.log("this is pan no", self.panno);
      const instance = axios.create({
        baseURL: "https://uatgateway.supermoney.in/mandate-services/mandate/digio/",
        headers: { "content-type": "application/json" },
      });

      //  var url = 'http://13.126.28.53:8080/MintReliance/MintReliance/kycCheck'
      var data = {
        customerId: self.custDetails.customerID,
        mandateId: mandate,
      };
      instance
        .post("get", data)

        .then(function (response) {
          console.log(response);
          const JSONData = response.data;

          console.log("successfully mandate done", JSONData.message);
          this.getBankDetails();

          self.$store.commit("routeChange", "end");

          self.progress = false;
        })
        .catch((error) => {
          self.errorText = "Network Error";
          console.log("display Error" + error);
          self.$store.commit("routeChange", "end");
        });
    },

    sendBankSMSPop()
    {
      this.bankSMSPop = true
    },

    getCreditScore()
    {





      var self = this
      // self.$store.commit("routeChange", "start");
      //
      // const instance = axios.create({
      //         // baseURL: 'https://cors-anywhere.herokuapp.com/http://13.126.29.47:8080/mintLoan/mintloan/', //LIVE
      //          baseURL: 'https://uatgateway.supermoney.in/experianservices/services/creditscore/',
      //       // baseURL: 'https://cors-anywhere.herokuapp.com/https://uatgateway.supermoney.in/tomcat/mintLoan/mintloan/', //DEV
      //       // baseURL: 'https://cors-anywhere.herokuapp.com/https://uatgateway.supermoney.in/tomcat/mintLoan/mintloan/', //live
      //    headers: {'content-type': 'application/json'}
      //  })
      //
      //
      //
      // var data = {
      //
      // customerId:self.$route.query.data,
      // referenceType : "Customer",
      // panNumber:self.panNumber,
      //
      //
      // };
      //
      //
      //
      //
      // instance.post('getLastCreditDetails',data)
      //
      // .then(function (response) {
      // console.log(response);
      // const JSONData = response.data;

      // self.cAISAccountDetailsList = JSONData.accountDetails
      // for(var i=0; i < self.cAISAccountDetailsList.length ; i++)
      // {
      //
      //
      //   if(self.caisDetailsposition == self.cAISAccountDetailsList[i].accountNumber)
      //   {
      //
      //     self.caisDetails = self.cAISAccountDetailsList[i]
      //   }
      //
      //
      // }
      self.AddressDetails = self.caisDetails.cAISHolderAddressDetails
      self.phoneDetails = self.caisDetails.cAISHolderPhoneDetails




      self.AddressDetails.forEach(function(address, index) {
  if (index < self.phoneDetails.length) {
    var phoneDetail = self.phoneDetails[index];
    address.telephoneNumber = phoneDetail.telephoneNumber;
    address.telephoneType = phoneDetail.telephoneType;
    address.telephoneExtension = phoneDetail.telephoneExtension;
    address.mobileTelephoneNumber = phoneDetail.mobileTelephoneNumber;
  }
});
      console.log("this is holder Dets",JSON.stringify(self.AddressDetails))


      if (self.caisDetails.cAISAccountHistory.length > 0) {
  const unique = [...new Set(self.caisDetails.cAISAccountHistory.map(item => item.year))];


  unique.forEach((year, index) => {
    let obj = { year };

    for (let i = 1; i <= 12; i++) {
      let array = self.caisDetails.cAISAccountHistory.filter(item => item.month === i && item.year === year);

      switch (i) {
        case 1:
          if (array.length > 0) {
            obj.jan = array[0].daysPastDue;
            obj.assetClassificationJan = array[0].assetClassification;
          } else {
            obj.jan = "---";
          }
          break;
        case 2:
          if (array.length > 0) {
            obj.feb = array[0].daysPastDue;
            obj.assetClassificationFeb = array[0].assetClassification;
          } else {
            obj.feb = "---";
          }
          break;
        case 3:
          if (array.length > 0) {
            obj.mar = array[0].daysPastDue;
            obj.assetClassificationMar = array[0].assetClassification;
          } else {
            obj.mar = "---";
          }
          break;
        case 4:
          if (array.length > 0) {
            obj.apr = array[0].daysPastDue;
            obj.assetClassificationApr = array[0].assetClassification;
          } else {
            obj.apr = "---";
          }
          break;
        case 5:
          if (array.length > 0) {
            obj.may = array[0].daysPastDue;
            obj.assetClassificationMay = array[0].assetClassification;
          } else {
            obj.may = "---";
          }
          break;
        case 6:
          if (array.length > 0) {
            obj.jun = array[0].daysPastDue;
            obj.assetClassificationJun = array[0].assetClassification;
          } else {
            obj.jun = "---";
          }
          break;
        case 7:
          if (array.length > 0) {
            obj.jul = array[0].daysPastDue;
            obj.assetClassificationJul = array[0].assetClassification;
          } else {
            obj.jul = "---";
          }
          break;
        case 8:
          if (array.length > 0) {
            obj.aug = array[0].daysPastDue;
            obj.assetClassificationAug = array[0].assetClassification;
          } else {
            obj.aug = "---";
          }
          break;
        case 9:
          if (array.length > 0) {
            obj.sep = array[0].daysPastDue;
            obj.assetClassificationSep = array[0].assetClassification;
          } else {
            obj.sep = "---";
          }
          break;
        case 10:
          if (array.length > 0) {
            obj.oct = array[0].daysPastDue;
            obj.assetClassificationOct = array[0].assetClassification;
          } else {
            obj.oct = "---";
          }
          break;
        case 11:
          if (array.length > 0) {
            obj.nov = array[0].daysPastDue;
            obj.assetClassificationNov = array[0].assetClassification;
          } else {
            obj.nov = "---";
          }
          break;
        case 12:
          if (array.length > 0) {
            obj.dec = array[0].daysPastDue;
            obj.assetClassificationDec = array[0].assetClassification;
          } else {
            obj.dec = "---";
          }
          break;
      }
    }

    self.dpdArray.push(obj);
  });


}

      // self.$store.commit("routeChange", "end");
      // self.progress = false;
      //
      // })
      // .catch(error => {
      // self.errorText = "Network Error";
      // console.log("display Error"+error)
      // self.$store.commit("routeChange", "end");
      //
      //
      // });

    },



    cancelMandate(mandate) {
      var self = this
      self.$store.commit("routeChange", "start");
      console.log("this is pan no", self.panno);
      const instance = axios.create({
        baseURL: "https://uatgateway.supermoney.in/mandate-services/mandate/digio/",
        headers: { "content-type": "application/json" },
      });

      //  var url = 'http://13.126.28.53:8080/MintReliance/MintReliance/kycCheck'
      var data = {
        customerId: self.custDetails.customerID,
        mandateId: mandate,
      };
      instance
        .post("cancel", data)

        .then(function (response) {
          console.log(response);
          const JSONData = response.data;

          console.log("successfully mandate done", JSONData.message);
          this.getBankDetails();

          self.$store.commit("routeChange", "end");

          self.progress = false;
        })
        .catch((error) => {
          self.errorText = "Network Error";
          console.log("display Error" + error);
          self.$store.commit("routeChange", "end");
        });
    },



    directBankMandategenerate(mandate)
  {


                var self =this

                self.$store.commit("routeChange", "start");

                const instance = axios.create({

                       baseURL: 'https://uatgateway.supermoney.in/mandate-services/mandate/digio/physical/form/',
                    // baseURL: 'https://cors-anywhere.herokuapp.com/http://13.126.29.47:8080/MintReliance/MintReliance/', //LIVE
                      // baseURL: 'https://cors-anywhere.herokuapp.com/https://uatgateway.supermoney.in/tomcat/MFInvestment/mfInvestment/', //DEV
                      // baseURL: 'https://cors-anywhere.herokuapp.com/https://uatgateway.supermoney.in/tomcat/MFInvestment/MFInvestment/', //live
                   headers: {'content-type': 'application/json'}
                 })


              //  var url = 'http://13.126.28.53:8080/MintReliance/MintReliance/kycCheck'
      var data = {
          mandateId: mandate,
          customerId:self.custDetails.customerID

          };
      instance.post('get',data)

      .then(function (response) {
        console.log(response);
        const JSONData = response.data;

        if (JSONData.mandateId != '') {


          self.fileDownloadUrl = JSONData.fileDownloadUrl
          // self.pubFileLocation = JSONData.pubFileLocation
          // self.mandateId = JSONData.mandateId
          // self.linkFlag = true

          // digio.init();
          // digio.submit(self.mandateId,custIdentifer);




          self.$store.commit("routeChange", "end");


        }

        else {
            self.errorEmail = true
            self.errorEmailText  = 'Could Not Create Bank Mandate'
            self.$store.commit("routeChange", "end");
        }

        self.progress = false;

    })
    .catch(error => {
        self.$store.commit("routeChange", "end");

      if (error) {

        console.log("display  =="+error);

      }




    });
  },





    rejectClick() {
      this.rejectPopFlag = true;
    },

    addBankClick() {
      this.addbankPopFlag = true;
    },

    nameFormatValidation() {
      var regpan = /^([a-zA-Z]+\s)*[a-zA-Z]+$/;
      return regpan.test(this.newAccHolderName) ? true : false;
    },

    ifscFormatValidation() {
      var regpan = /^[A-Za-z]{4}\d{7}$/;
      return regpan.test(this.newIFSCcode) ? true : false;
    },

    addNewBank() {
      var character = /[ `!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?~]/;
      if (character.test(this.newBankAccNo)) {
        this.accuntFlag = false;
      } else {
        this.accuntFlag = true;
      }

      if (character.test(this.newBranch)) {
        this.branchValFlag = false;
      } else {
        this.branchValFlag = true;
      }

      if (character.test(this.newBranchCity)) {
        this.branchcityValFlag = false;
      } else {
        this.branchcityValFlag = true;
      }

      if (this.newBankAccNo != "" && this.accuntFlag === true) {
        this.accErrorFlag = false;

        if (this.newAccHolderName != "" && this.nameFormatValidation()) {
          this.accNameFlag = false;

          if (this.newIFSCcode != "" && this.ifscFormatValidation()) {
            this.ifscCodeFlag = false;

            if (this.newaccType != "") {
              this.accTypeFlag = false;
              var self = this;
              self.$store.commit("routeChange", "start");

              const instance = axios.create({
                baseURL:
                  "https://uatgateway.supermoney.in/tomcat/mintLoan/mintloan/",

                headers: { "content-type": "application/json" },
              });
              var data = {

                accNo: self.newBankAccNo,
                accType: self.newaccType,
                accHoldName: self.newAccHolderName,
                defaultAccountFlag: true,
                personalAccountFlag: true,
                ifscCode: self.newIFSCcode,
                micrCode: self.newMICRCode,
              };
              var timestamp = Math.round(+new Date() / 1000);
                var msgHeader = {
                  authToken: localStorage.getItem("authtoken"), //dynamic
                  loginId: self.mobileNumber,
                  channelType: "M",
                  consumerId: "414",
                  deviceId: "SwiggyLoans",
                  source: "webDirect",
                };
                var deviceFPmsgHeader = {
                  clientIPAddress: "192.168.0.122",
                  connectionMode: "WIFI",
                  country: "United States",
                  deviceManufacturer: "Xiaomi",
                  deviceModelNo: "Mi A2",
                  dualSim: false,
                  imeiNo: "09d9212a07553637",
                  latitude: "",
                  longitude: "",
                  nwProvider: "xxxxxxxx",
                  osName: "Android",
                  osVersion: 28,
                  timezone: "Asia/Kolkata",
                  versionCode: "58",
                  versionName: "5.5.1",
                };

                var employeeDetails = { data, deviceFPmsgHeader, msgHeader };
              instance
                .post("addBankForMerchant", employeeDetails)

                .then(function (response) {
                  console.log(response);
                  const JSONData = response.data;

                  if (JSONData.data.successFlag === true) {
                    self.addbankPopFlag = false;
                    self.getBankDetails();
                  } else {

                    if (JSONData.header.hostStatus === "E") {
                        self.GeneralErrorBank = true;
                        self.errorMessageBank = JSONData.header.error.errorDesc;
                      } else {
                        self.GeneralErrorBank = true;
                        self.errorMessageBank = JSONData.data.message;
                      }

                    self.$store.commit("routeChange", "end");

                    self.supplierID = "";
                    self.newBankAccNo = "";
                    self.newIFSCcode = "";
                    self.newMICRCode = "";
                    self.newAccHolderName = "";
                    self.newaccType = "";
                    self.newBankName = "";
                    self.newBranch = "";
                    self.newBranchCity = "";
                    self.supplierBankID = "";
                  }
                })
                .catch(function (error) {
                  if (error.response) {
                    console.log(error.response.data);
                    console.log(error.response.status);
                    console.log(error.response.headers);
                    self.GeneralError = true;
                    self.errorMessage = error.response.data.errors[0];
                    self.$store.commit("routeChange", "end");
                  }
                });
            } else {
              this.accTypeFlag = true;
              this.accTypeError = "Please Select Account Type";
            }
          } else {
            this.ifscCodeFlag = true;
            this.ifscCodeError = "Please Enter Valid IFSC Code";
          }
        } else {
          this.accNameFlag = true;
          this.accNameError = "Please Enter Valid Account Holder Name";
        }
      } else {
        this.accErrorFlag = true;
        this.accFlagMessage = "Please Enter Valid Bank Account Number";
      }
    },

    approveBank() {
      var self = this;

      self.$store.commit("routeChange", "start");

      const instance = axios.create({
        baseURL: "https://uatgateway.supermoney.in/tomcat/mintLoan/mintloan/stage/",

        headers: { "content-type": "application/json" },
      });
      var data = {
        customerId: Number(self.$route.query.data),
        profileId: Number(self.custDetails.profileID),
        stageName: "BANK",
        stageStatus: "VERIFIED",
        relatedId: self.bankDetailsSet.iD,
      };
      instance
        .post("update", data)

        .then(function (response) {
          console.log(response);
          const JSONData = response.data;

          if (JSONData.successFlag === true) {
            // self.verifyBank()
            self.getBankDetails();
          } else {
            self.GeneralError = true;
            self.errorMessage = JSONData.message;
            self.$store.commit("routeChange", "end");
          }
        })
        .catch(function (error) {
          if (error.response) {
            console.log(error.response.data);
            console.log(error.response.status);
            console.log(error.response.headers);
            self.GeneralError = true;
            self.errorMessage = error.response.data.errors[0];
            self.$store.commit("routeChange", "end");
          }
        });
    },

    RejectBank(item) {
      var self = this;

      self.$store.commit("routeChange", "start");

      const instance = axios.create({
        baseURL: "https://uatgateway.supermoney.in/tomcat/mintLoan/mintloan/stage/",

        headers: { "content-type": "application/json" },
      });
      var data = {
        customerId: Number(self.$route.query.data),
        profileId: Number(self.custDetails.profileID),
        stageName: "BANK",
        stageStatus: "REJECTED",
        relatedId: self.bankDetailsSet.iD,
      };
      instance
        .post("update", data)

        .then(function (response) {
          console.log(response);
          const JSONData = response.data;

          if (JSONData.successFlag === true) {
            self.getBankDetails();
          } else {
            self.GeneralError = true;
            self.errorMessage = JSONData.message;
            self.$store.commit("routeChange", "end");
          }
        })
        .catch(function (error) {
          if (error.response) {
            console.log(error.response.data);
            console.log(error.response.status);
            console.log(error.response.headers);
            self.GeneralError = true;
            self.errorMessage = error.response.data.errors[0];
            self.$store.commit("routeChange", "end");
          }
        });
    },
    rejectSupplier() {
      var self = this;

      self.$store.commit("routeChange", "start");

      const instance = axios.create({
        baseURL:
          "https://uatgateway.supermoney.in/invoice-finance-services/invoice-services/supplier/",

        headers: { "content-type": "application/json" },
      });
      var data = {
        supplierId: self.supplierDetails[0].supplierId,
        rejectReason: self.rejectReason,
      };
      instance
        .post("reject", data)

        .then(function (response) {
          console.log(response);
          const JSONData = response.data;

          if (JSONData.status === true) {
            self.rejectPopFlag = false;
            self.supplierStatus = "Reject";
            self.hideButton = false;
            self.getInvoicesAfterApprove();
          } else {
            self.GeneralError = true;
            self.errorMessage = "Invalid Details";
            self.$store.commit("routeChange", "end");
          }
        })
        .catch(function (error) {
          if (error.response) {
            console.log(error.response.data);
            console.log(error.response.status);
            console.log(error.response.headers);
            self.GeneralError = true;
            self.errorMessage = error.response.data.errors[0];
            self.$store.commit("routeChange", "end");
          }
        });
    },

    getInvoices() {
      this.$store.commit("routeChange", "start");
      var self = this;
      var url =
        // 'https://uatgateway.supermoney.in/invoice-finance-services/invoice-services/finance/invoices/get?'+self.orderID;
        "https://uatgateway.supermoney.in/invoice-finance-services/invoice-services/supplier/get?status=" +
        self.supplierStatus +
        "&id=" +
        self.supplierID;
      // 'https://uatgateway.supermoney.in/invoice-finance-services/invoice-services/supplier/get?id=' +self.supplierID;

      axios
        .get(url)
        .then(function (response) {
          // handle success

          const JSONData = response.data;
          console.log("this is the data", response.data);

          self.awaitingSupplierDetails =
            JSONData.supplierDetails.AWAITING_APPROVAL_SUPPLIER;
          self.rejectSupplierDetails = JSONData.supplierDetails.REJECT_SUPPLIER;
          self.activeSupplierDetails =
            JSONData.supplierDetails.APPROVED_SUPPLIER;

          if (self.activeTab === "1") {
            self.supplierDetails = self.awaitingSupplierDetails;
            self.supplierBankID =
              self.supplierDetails[0].supplierBankDetails[0].supplierBankId;
            self.hideButton = true;
          } else if (self.activeTab === "2") {
            self.supplierDetails = self.activeSupplierDetails;
            self.supplierBankID =
              self.supplierDetails[0].supplierBankDetails[0].supplierBankId;
          } else {
            self.supplierDetails = self.rejectSupplierDetails;
            self.supplierBankID =
              self.supplierDetails[0].supplierBankDetails[0].supplierBankId;
          }

          // for(var i=0; i< self.supplierDetails[0].supplierBankDetails.length ; i++)
          // {
          //   if(self.supplierDetails[0].supplierBankDetails[i].pennyDropVerified === true)
          // }

          self.$store.commit("routeChange", "end");
        })
        .catch(function (error) {
          // handle error
          console.log("display  ==" + error);
          self.$store.commit("routeChange", "end");
        })
        .finally(function () {
          self.$store.commit("routeChange", "end");

          // always executed
        });
    },

    getInvoicesAfterApprove() {
      this.$store.commit("routeChange", "start");
      var self = this;
      var url =
        // 'https://uatgateway.supermoney.in/invoice-finance-services/invoice-services/finance/invoices/get?'+self.orderID;
        "https://uatgateway.supermoney.in/invoice-finance-services/invoice-services/supplier/get?status=" +
        self.supplierStatus +
        "&id=" +
        self.supplierID;
      // 'https://uatgateway.supermoney.in/invoice-finance-services/invoice-services/supplier/get?id=' +self.supplierID;

      axios
        .get(url)
        .then(function (response) {
          // handle success

          const JSONData = response.data;
          console.log("this is the data", response.data);

          self.awaitingSupplierDetails =
            JSONData.supplierDetails.AWAITING_APPROVAL_SUPPLIER;
          self.rejectSupplierDetails = JSONData.supplierDetails.REJECT_SUPPLIER;
          self.activeSupplierDetails =
            JSONData.supplierDetails.APPROVED_SUPPLIER;

          if (self.supplierStatus === "Approved") {
            self.supplierDetails = self.activeSupplierDetails;
            self.supplierBankID =
              self.supplierDetails[0].supplierBankDetails[0].supplierBankId;
          } else if (self.supplierStatus === "Reject") {
            self.supplierDetails = self.rejectSupplierDetails;
            self.supplierBankID =
              self.supplierDetails[0].supplierBankDetails[0].supplierBankId;
          } else {
            self.supplierDetails = self.awaitingSupplierDetails;
            self.supplierBankID =
              self.supplierDetails[0].supplierBankDetails[0].supplierBankId;
          }

          self.$store.commit("routeChange", "end");
        })
        .catch(function (error) {
          // handle error
          console.log("display  ==" + error);
          self.$store.commit("routeChange", "end");
        })
        .finally(function () {
          self.$store.commit("routeChange", "end");

          // always executed
        });
    },
  },
  components: { BBreadcrumb, BCardText, BButton, BBreadcrumbItem, BRow, BCol,VueSlickCarousel },
  mounted() {
    this.$emit("setAppClasses", "invoice-page");
  },
};
</script>
<style scoped>
.dot {
  display: inline-block;
  border-radius: 50%;
  margin: auto;
  background-color: #fff;
  block-size: 16px;
  inline-size: 16px;
}

.text-custom {
  text-align: start;
}

.v-expansion-panel--active {
  background: #f1f1f2;
  border-inline-start: 3px solid #674af5;
}

.v-label {
  color: #4b465c;
  font-size: 15px;
  font-weight: 500;
}

@media (max-width: 600px) {
  .text-custom {
    text-align: center;
  }

  .devide-5 {
    inline-size: 50%;
  }
}
</style>


<style lang="scss">
@media print {
  .invoice-page {
    * {
      visibility: hidden;
    }

    #content-area {
      margin: 0 !important;
    }

    .vs-con-table {
      .vs-con-tbody {
        overflow: hidden !important;
      }
    }

    #invoice-container,
    #invoice-container * {
      visibility: visible;
    }
    #invoice-container {
      position: absolute;
      left: 0;
      top: 0;
      box-shadow: none;
    }
  }
}

@page {
  size: auto;
}
</style>


<style>
.no-padding td {
    padding-left: 5px;
  }
  .no-padding th {
      padding-left: 5px;
    }
h5 {
  white-space: nowrap;
  width: 30px;

}
.left{
 float: left;
 width: 2%;
 height: 20px;
 border: none;
 margin-top:35px;
}

.internal{
 width: 200px;
 height: 40%;
 border: 1px solid black;
 display: inline-block;
 margin:10px;
 text-align: center;
}

.center{
 float: left;
 width: 92%;
 height: 200px;
 border: none;
 margin: 1px;
 overflow: hidden;
 white-space: nowrap;
}

.right{
 float: right;
 width: 2%;
 height: 20px;
 border: none;
 margin-top:35px;
}
</style>
